import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icon/amway-cc-logo-b.svg'
import _imports_1 from '@/assets/icon/icon-team.svg'
import _imports_2 from '@/assets/icon/icon-reward.svg'
import _imports_3 from '@/assets/icon/icon-group-people.svg'
import _imports_4 from '@/assets/icon/icon-register-w.svg'
import _imports_5 from '@/assets/icon/icon-people.svg'
import _imports_6 from '@/assets/icon/icon-edit-profile.svg'
import _imports_7 from '@/assets/icon/icon-back-to.svg'
import _imports_8 from '@/assets/icon/amway-cc-logo-m.svg'
import _imports_9 from '@/assets/images/activity/banner-prop-left.svg'
import _imports_10 from '@/assets/images/activity/banner-prop-right.svg'
import _imports_11 from '@/assets/images/board/reward-w1-r1.svg'
import _imports_12 from '@/assets/images/board/reward-w1-r21.svg'
import _imports_13 from '@/assets/images/board/reward-w1-r41.svg'
import _imports_14 from '@/assets/images/board/reward-w6-r1.svg'
import _imports_15 from '@/assets/images/board/reward-w6-r21.svg'
import _imports_16 from '@/assets/images/board/reward-w6-r41.svg'
import _imports_17 from '@/assets/images/activity/announce-people.svg'
import _imports_18 from '@/assets/images/activity/store.svg'
import _imports_19 from '@/assets/images/activity/banner-product.svg'
import _imports_20 from '@/assets/images/activity/banner-bottom-2.svg'
import _imports_21 from '@/assets/images/activity/banner-bottom1-m.svg'
import _imports_22 from '@/assets/images/landing/creator-challenge-logo.svg'
import _imports_23 from '@/assets/images/activity/cloud-left.svg'
import _imports_24 from '@/assets/images/activity/cloud-right.svg'
import _imports_25 from '@/assets/images/activity/banner-bottom.svg'
import _imports_26 from '@/assets/images/activity/banner-bottom-flag-m.svg'
import _imports_27 from '@/assets/images/activity/bg-dot.svg'
import _imports_28 from '@/assets/images/activity/grass.svg'
import _imports_29 from '@/assets/images/activity/grass2.svg'
import _imports_30 from '@/assets/images/activity/mountain-left.svg'
import _imports_31 from '@/assets/images/activity/flag-start.svg'
import _imports_32 from '@/assets/images/activity/mountain-right.svg'
import _imports_33 from '@/assets/images/activity/mark.svg'
import _imports_34 from '@/assets/images/activity/icon_live.svg'
import _imports_35 from '@/assets/images/activity/week1.svg'
import _imports_36 from '@/assets/images/activity/flower-pink.svg'
import _imports_37 from '@/assets/images/activity/week2.svg'
import _imports_38 from '@/assets/images/activity/flower-orange.svg'
import _imports_39 from '@/assets/images/activity/week3.svg'
import _imports_40 from '@/assets/images/activity/week4.svg'
import _imports_41 from '@/assets/images/activity/week5.svg'
import _imports_42 from '@/assets/images/activity/week6.svg'
import _imports_43 from '@/assets/images/activity/week7.svg'
import _imports_44 from '@/assets/images/activity/week8.svg'
import _imports_45 from '@/assets/images/activity/week9.svg'
import _imports_46 from '@/assets/images/activity/week10.svg'
import _imports_47 from '@/assets/images/activity/go_japan.svg'
import _imports_48 from '@/assets/images/activity/act-mountain.svg'
import _imports_49 from '@/assets/images/activity/mountain-m.svg'
import _imports_50 from '@/assets/images/activity/trophy.svg'
import _imports_51 from '@/assets/images/activity/calendar.svg'
import _imports_52 from '@/assets/images/activity/medal.svg'
import _imports_53 from '@/assets/images/activity/reward.svg'
import _imports_54 from '@/assets/icon/amway-logo.svg'
import _imports_55 from '@/assets/icon/icon-phone.svg'
import _imports_56 from '@/assets/icon/icon-close-modal.svg'
import _imports_57 from '@/assets/icon/icon-back.svg'
import _imports_58 from '@/assets/images/activity/point-icon.svg'
import _imports_59 from '@/assets/images/activity/modal-thumbnail-1.png'
import _imports_60 from '@/assets/images/activity/all-social.svg'
import _imports_61 from '@/assets/images/activity/product2.png'
import _imports_62 from '@/assets/images/activity/product3.png'
import _imports_63 from '@/assets/images/activity/product4.png'
import _imports_64 from '@/assets/images/activity/product5.png'
import _imports_65 from '@/assets/images/activity/product7.png'
import _imports_66 from '@/assets/images/activity/product9.png'
import _imports_67 from '@/assets/images/activity/cloud-end-left.svg'
import _imports_68 from '@/assets/images/activity/cloud-end-right.svg'
import _imports_69 from '@/assets/images/activity/fireworks.svg'
import _imports_70 from '@/assets/images/activity/plain-end.svg'
import _imports_71 from '@/assets/images/activity/creator-end.svg'
import _imports_72 from '@/assets/images/activity/people-end.svg'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-area desktop" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_5 = { class: "header-right" }
const _hoisted_6 = { class: "header-menu" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("ประกาศผลรางวัลชนะเลิศ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
  /*#__PURE__*/_createTextVNode("รายละเอียดกิจกรรม")
], -1)
const _hoisted_18 = { class: "profile-area" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  class: "profile-info",
  id: "profile-info"
}
const _hoisted_21 = { class: "profile-info-area" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_23 = { class: "profile-info-name" }
const _hoisted_24 = { class: "profile-info-id" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("โปรไฟล์ของฉัน ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก ")
], -1)
const _hoisted_28 = { class: "header-area mobile" }
const _hoisted_29 = { class: "header-logo-area" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_31 = {
  class: "profile-area",
  id: "profile-area-m"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  class: "profile-info",
  id: "profile-info-m"
}
const _hoisted_34 = { class: "profile-info-area" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_36 = { class: "profile-info-name" }
const _hoisted_37 = { class: "profile-info-id" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("โปรไฟล์ของฉัน ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก ")
], -1)
const _hoisted_41 = {
  class: "sub-menu",
  id: "sub-menu"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ ")
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์ ")
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode("ประกาศผลรางวัลชนะเลิศ ")
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ ")
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์ ")
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
  /*#__PURE__*/_createTextVNode("รายละเอียดกิจกรรม ")
], -1)
const _hoisted_53 = {
  key: 0,
  class: "act-banner act-banner-2"
}
const _hoisted_54 = { class: "container" }
const _hoisted_55 = { class: "act-banner-content" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "banner-prop-left"
}, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  class: "banner-prop-right"
}, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h6", null, "ทีมของคุณ", -1)
const _hoisted_59 = { class: "text-white" }
const _hoisted_60 = { class: "f-bold text-white" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  class: "act-banner-image"
}, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h6", { class: "act-banner-product-name" }, [
  /*#__PURE__*/_createTextVNode("นิวทริไลท์ ออลแพลนท์ โปรตีน "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ท่านละ 1 กระป๋อง มูลค่า 1,100 บาท ")
], -1)
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  class: "act-banner-image"
}, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h6", { class: "act-banner-product-name" }, [
  /*#__PURE__*/_createTextVNode("นิวทริไลท์ น้ำมันปลา"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ท่านละ 1 กระป๋อง มูลค่า 800 บาท ")
], -1)
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = { key: 2 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  class: "act-banner-image"
}, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h6", { class: "act-banner-product-name" }, [
  /*#__PURE__*/_createTextVNode("นิวทริไลท์ วิตามินบี พลัส"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ท่านละ 1 กระป๋อง มูลค่า 480 บาท ")
], -1)
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = { key: 3 }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  class: "act-banner-image"
}, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h6", { class: "act-banner-product-name" }, [
  /*#__PURE__*/_createTextVNode("นิวทริไลท์ โพรไบโอติก"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ท่านละ 1 กระป๋อง มูลค่า 1,500 บาท ")
], -1)
const _hoisted_76 = [
  _hoisted_74,
  _hoisted_75
]
const _hoisted_77 = { key: 4 }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  class: "act-banner-image"
}, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("h6", { class: "act-banner-product-name" }, [
  /*#__PURE__*/_createTextVNode("นิวทริไลท์ การ์ลิค"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ท่านละ 1 กระป๋อง มูลค่า 1,088 บาท ")
], -1)
const _hoisted_80 = [
  _hoisted_78,
  _hoisted_79
]
const _hoisted_81 = { key: 5 }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  class: "act-banner-image"
}, null, -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("h6", { class: "act-banner-product-name" }, [
  /*#__PURE__*/_createTextVNode("เอ็น บาย นิวทริไลท์ เอ็น* ชา"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ท่านละ 1 กระป๋อง มูลค่า 540 บาท ")
], -1)
const _hoisted_84 = [
  _hoisted_82,
  _hoisted_83
]
const _hoisted_85 = { key: 6 }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  class: "act-banner-image"
}, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("h6", { class: "act-banner-product-name mt-16" }, [
  /*#__PURE__*/_createTextVNode("ทีมของคุณไม่ได้รับรางวัลในสัปดาห์นี้"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("สู้กันใหม่ในสัปดาห์ถัดไป")
], -1)
const _hoisted_88 = [
  _hoisted_86,
  _hoisted_87
]
const _hoisted_89 = {
  key: 7,
  href: "https://www.surveymonkey.com/r/creatorschallenge",
  target: "_blank",
  class: "act-banner-btn",
  style: {"display":"block","width":"328px","margin":"8px auto"}
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_18 }),
  /*#__PURE__*/_createTextVNode(" เลือกสาขาเข้ารับรางวัล ")
], -1)
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "act-banner-checkpoint" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_19,
    class: "banner-product"
  }),
  /*#__PURE__*/_createElementVNode("h6", null, [
    /*#__PURE__*/_createTextVNode("ตรวจสอบรายชื่อผู้ที่ได้รับรางวัลพิเศษเพิ่มเติมจากคะแนนปกติ "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://m.facebook.com/groups/586620419362293?view=files",
      target: "_blank",
      class: "text-success"
    }, "ได้ที่นี่")
  ])
], -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_20,
  alt: "Amway Creator Challenge",
  class: "banner-bottom banner-bottom-d"
}, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_21,
  alt: "Amway Creator Challenge",
  class: "banner-bottom banner-bottom-m"
}, null, -1)
const _hoisted_95 = {
  key: 1,
  class: "act-banner act-banner-1"
}
const _hoisted_96 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"act-banner-logo\"><img src=\"" + _imports_22 + "\" alt=\"Amway Creator Challenge\"></div><div class=\"act-banner-detail\"><h4><span class=\"font-large text-success\">70</span><span class=\"font-medium text-success\">วัน</span> เปลี่ยนความชอบเป็นรายได้ <br>ด้วยธุรกิจแอมเวย์ มุ่งสู่เป้าหมายแอมเวย์ <span class=\"font-medium text-success\">70 ปี</span></h4></div></div><img src=\"" + _imports_23 + "\" class=\"cloud-left\"><img src=\"" + _imports_24 + "\" class=\"cloud-right\"><img src=\"" + _imports_25 + "\" alt=\"Amway Creator Challenge\" class=\"banner-bottom banner-bottom-d\"><img src=\"" + _imports_21 + "\" alt=\"Amway Creator Challenge\" class=\"banner-bottom banner-bottom-m\"><img src=\"" + _imports_26 + "\" alt=\"Amway Creator Challenge\" class=\"banner-bottom-flag banner-bottom-m\">", 6)
const _hoisted_102 = [
  _hoisted_96
]
const _hoisted_103 = { class: "act-background" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_27,
  class: "bg-dot dot-top-left visible-desktop"
}, null, -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_27,
  class: "bg-dot dot-top-right visible-desktop"
}, null, -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_28,
  class: "grass-top-left visible-desktop"
}, null, -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_29,
  class: "grass-top-right visible-desktop"
}, null, -1)
const _hoisted_108 = { class: "container" }
const _hoisted_109 = /*#__PURE__*/_createStaticVNode("<div class=\"act-header\"><div class=\"act-header-content\"><img src=\"" + _imports_30 + "\" class=\"mountain-left\"><img src=\"" + _imports_31 + "\" class=\"flag-start\"><img src=\"" + _imports_32 + "\" class=\"mountain-right\"><div class=\"act-header-detail\"><h3>กิจกรรมรายสัปดาห์</h3><h5 class=\"text-success\">5 มี.ค - 13 พ.ค 65</h5></div></div></div>", 1)
const _hoisted_110 = { class: "container-activity visible-desktop" }
const _hoisted_111 = {
  class: "act-corner-2 station-first station-one",
  style: {"background-color":"#aaa"}
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "สัปดาห์ที่ 1"),
  /*#__PURE__*/_createElementVNode("p", null, "5 - 11 มี.ค 65")
], -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("p", null, "5 - 11 มี.ค 65", -1)
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = { class: "thumbnail-checkpoint" }
const _hoisted_116 = { class: "thumbnail" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_118 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> เรียนรู้การสร้างแบรนด์ Health &amp; Wellness <br>อย่างไรให้น่าสนใจแบบคุณ </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 5 มี.ค. 65 เวลา 13.00-15.00 น.</b><br>โดยดิจิทัลโค้ชโซอี้ <span class=\"text-success f-bold\">ภญ. โสภา พิมพ์สิริพานิชย์</span></p></div></div>", 1)
const _hoisted_119 = { class: "act-line-center station-one-hover" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "สัปดาห์ที่ 2"),
  /*#__PURE__*/_createElementVNode("p", null, "12 - 18 มี.ค 65")
], -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("p", null, "12 - 18 มี.ค 65", -1)
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = { class: "thumbnail-checkpoint" }
const _hoisted_124 = { class: "thumbnail" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_126 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> เรียนรู้การเขียนคอนเทนต์ Health &amp; Wellness <br>อย่างไรให้โดนใจ และเทคนิคการขายแบบไม่ขาย </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 12 มี.ค. 65 เวลา 13.00-15.00 น.</b><br>โดยดิจิทัลโค้ชโซอี้ <span class=\"text-success f-bold\">ภญ.โสภา พิมพ์สิริพานิชย์</span></p></div></div>", 1)
const _hoisted_127 = { class: "act-corner-1" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "สัปดาห์ที่ 3"),
  /*#__PURE__*/_createElementVNode("p", null, "19 - 25 มี.ค 65")
], -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("p", null, "19 - 25 มี.ค 65", -1)
const _hoisted_130 = [
  _hoisted_129
]
const _hoisted_131 = { class: "thumbnail-checkpoint" }
const _hoisted_132 = { class: "thumbnail" }
const _hoisted_133 = { class: "thumbnail-checkpoint" }
const _hoisted_134 = { class: "thumbnail" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_136 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> การสร้างเพอร์ซันนัล แบรนดิง <br>จะช่วยให้ทำธุรกิจแอมเวย์ง่ายขึ้นอย่างไร? </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 20 มี.ค. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-bold\">นพ.ศวัสพล คูณชัยพานิชย์ - ภญ.ณัฐนันท์ งานเลิศ</span><br>นักธุรกิจแอมเวย์ระดับเพชรสองผู้สถาปนา และ <br><span class=\"text-success f-bold\">คุณปัญจพล จุรีเกษ-คุณภารดี ปิยนันทวารินทร์</span><br>นักธุรกิจแอมเวย์ระดับเพชรคู่ </p></div></div>", 1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_35,
  class: "flag-icon-1"
}, null, -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("div", { class: "flag-icon-detail flag-icon-1-detail" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "21 มี.ค. 65")
], -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_36,
  class: "flower-pink"
}, null, -1)
const _hoisted_140 = { class: "act-corner-2" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "สัปดาห์ที่ 4"),
  /*#__PURE__*/_createElementVNode("p", null, "26 มี.ค - 1 เม.ย. 65")
], -1)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("p", null, "26 มี.ค - 1 เม.ย. 65", -1)
const _hoisted_143 = [
  _hoisted_142
]
const _hoisted_144 = { class: "thumbnail-checkpoint" }
const _hoisted_145 = { class: "thumbnail" }
const _hoisted_146 = { class: "thumbnail-checkpoint" }
const _hoisted_147 = { class: "thumbnail" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_149 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> ร่วมค้นหาแรงบันดาลใจ Health &amp; Wellness <br>ในการทำคอนเทนต์สุขภาพกับตัวจริง </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 26 มี.ค. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-bold\">คุณพลวัต วิทยรุ่งโรจน์</span> และ <span class=\"text-success f-bold\">คุณพิมพ์อร โมกขะสมิต</span></p></div></div>", 1)
const _hoisted_150 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_37,
  class: "flag-icon-2"
}, null, -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "flag-icon-detail flag-icon-2-detail" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "28 มี.ค. 65")
], -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_38,
  class: "flower-orange"
}, null, -1)
const _hoisted_153 = { class: "act-line-center" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "สัปดาห์ที่ 5"),
  /*#__PURE__*/_createElementVNode("p", null, "02 - 08 เม.ย 65")
], -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("p", null, "02 - 08 เม.ย 65", -1)
const _hoisted_156 = [
  _hoisted_155
]
const _hoisted_157 = { class: "thumbnail-checkpoint" }
const _hoisted_158 = { class: "thumbnail" }
const _hoisted_159 = { class: "thumbnail-checkpoint" }
const _hoisted_160 = { class: "thumbnail" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_162 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> นำเสนอคอนเทนต์ผลิตภัณฑ์นิวทริไลท์ <br>ผ่านการขายแบบไม่ขายอย่างไร ให้น่าสนใจบนโซเชียลมีเดีย </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 2 เม.ย. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-bold\">คุณพรพิมล ผู้พัฒน์-คุณเจตน์กวิน โพธิ์ใบกุล</span><br>นักธุรกิจแอมเวย์ระดับเพชรบริหาร และ <br><span class=\"text-success f-bold\">คุณณรุส-คุณสมรศรี มหัคฆพงศ์</span> นักธุรกิจแอมเวย์ระดับเพชรคู่ </p></div></div>", 1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_39,
  class: "flag-icon-3"
}, null, -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", { class: "flag-icon-detail flag-icon-3-detail" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "4 เม.ย. 65")
], -1)
const _hoisted_165 = { class: "act-corner-1" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "สัปดาห์ที่ 6"),
  /*#__PURE__*/_createElementVNode("p", null, "09 - 15 เม.ย 65")
], -1)
const _hoisted_167 = /*#__PURE__*/_createElementVNode("p", null, "09 - 15 เม.ย 65", -1)
const _hoisted_168 = [
  _hoisted_167
]
const _hoisted_169 = { class: "thumbnail-checkpoint" }
const _hoisted_170 = { class: "thumbnail" }
const _hoisted_171 = { class: "thumbnail-checkpoint" }
const _hoisted_172 = { class: "thumbnail" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_174 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> เรียนรู้กับแอมเวย์ครีเอเตอร์ ในหัวข้อการแต่งภาพสไตล์ <br>Health &amp; Wellness ด้วยแอปพลิเคชัน ยอดฮิต </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 9 เม.ย. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-fold\">คุณนิชกานต์ อ้วนเจริญ</span> นักธุรกิจแอมเวย์ระดับแพลตินัม <br>และ <span class=\"text-success f-fold\">คุณชิดชนก อินทะกาล - คุณณัฐพงศ์ เสรีนนท์ชัย</span><br>นักธุรกิจแอมเวย์ระดับแพลตินัมสองผู้สถาปนา </p></div></div>", 1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_40,
  class: "flag-icon-4"
}, null, -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("div", { class: "flag-icon-detail flag-icon-4-detail" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "11 เม.ย. 65")
], -1)
const _hoisted_177 = { class: "act-corner-2 station-one" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "สัปดาห์ที่ 7"),
  /*#__PURE__*/_createElementVNode("p", null, "16 - 22 เม.ย 65")
], -1)
const _hoisted_179 = /*#__PURE__*/_createElementVNode("p", null, "16 - 22 เม.ย 65", -1)
const _hoisted_180 = [
  _hoisted_179
]
const _hoisted_181 = { class: "thumbnail-checkpoint" }
const _hoisted_182 = { class: "thumbnail" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_184 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> เรียนรู้การสร้างคอมมิวนิตีออนไลน์ <br>Health &amp; Wellness ในแบบฉบับของคุณ </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 16 เม.ย. 65 เวลา 13.00-15.00 น.</b><br>โดยดิจิทัลโค้ช <span class=\"text-success f-bold\">ครูทิป คุณมัณฑิตา จินดา</span></p></div></div>", 1)
const _hoisted_185 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_41,
  class: "flag-icon-5"
}, null, -1)
const _hoisted_186 = /*#__PURE__*/_createElementVNode("div", { class: "flag-icon-detail flag-icon-5-detail" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "18 เม.ย. 65")
], -1)
const _hoisted_187 = { class: "act-line-center" }
const _hoisted_188 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "สัปดาห์ที่ 8"),
  /*#__PURE__*/_createElementVNode("p", null, "23 - 29 เม.ย 65")
], -1)
const _hoisted_189 = /*#__PURE__*/_createElementVNode("p", null, "23 - 29 เม.ย 65", -1)
const _hoisted_190 = [
  _hoisted_189
]
const _hoisted_191 = { class: "thumbnail-checkpoint" }
const _hoisted_192 = { class: "thumbnail" }
const _hoisted_193 = { class: "thumbnail-checkpoint" }
const _hoisted_194 = { class: "thumbnail" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_196 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> เรียนรู้การสร้างคอมมิวนิตีออนไลน์ <br>Health &amp; Wellness สไตล์แอมเวย์ </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 23 เม.ย. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success\">คุณจิรศักดิ์ อั้นใจเอก - คุณชนากานต์ ปานแก้ว</span><br>นักธุรกิจแอมเวย์ระดับเพชร และ <br><span class=\"text-success\">คุณพีระ พันธุ์พิพัฒน์ - คุณชนัดดา ปรีชาหาญ</span> นักธุรกิจแอมเวย์ระดับเพชรบริหารสองผู้สถาปนา </p></div></div>", 1)
const _hoisted_197 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_42,
  class: "flag-icon-6"
}, null, -1)
const _hoisted_198 = /*#__PURE__*/_createElementVNode("div", { class: "flag-icon-detail flag-icon-6-detail" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "25 เม.ย. 65")
], -1)
const _hoisted_199 = { class: "act-corner-1 station-one" }
const _hoisted_200 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "สัปดาห์ที่ 9"),
  /*#__PURE__*/_createElementVNode("p", null, "30 เม.ย - 06 พ.ค 65")
], -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("p", null, "30 เม.ย - 06 พ.ค 65", -1)
const _hoisted_202 = [
  _hoisted_201
]
const _hoisted_203 = { class: "thumbnail-box" }
const _hoisted_204 = { class: "thumbnail" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_206 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> ข้อมูลในโซเชียลมีเดีย สามารถนำมาปรับใช้ <br>กับการทำคอนเทนต์ ของเราได้อย่างไร? </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 1 พ.ค. 65 เวลา 13.00-14.00 น.</b><br>โดย <span class=\"text-success\">คุณพุทธศักดิ์ ตันติสุทธิเวท</span><br>Data Research Manager บริษัท WISESIGHT </p></div></div>", 1)
const _hoisted_207 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_43,
  class: "flag-icon-7"
}, null, -1)
const _hoisted_208 = /*#__PURE__*/_createElementVNode("div", { class: "flag-icon-detail flag-icon-7-detail" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "2 พ.ค. 65")
], -1)
const _hoisted_209 = { class: "act-corner-2" }
const _hoisted_210 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "สัปดาห์ที่ 10"),
  /*#__PURE__*/_createElementVNode("p", null, "07 - 13 พ.ค 65")
], -1)
const _hoisted_211 = /*#__PURE__*/_createElementVNode("p", null, "07 - 13 พ.ค 65", -1)
const _hoisted_212 = [
  _hoisted_211
]
const _hoisted_213 = { class: "thumbnail-checkpoint" }
const _hoisted_214 = { class: "thumbnail" }
const _hoisted_215 = { class: "thumbnail-checkpoint" }
const _hoisted_216 = { class: "thumbnail" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_218 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> เรื่องราวความสำเร็จของการทำคอมมิวนิตี <br>Health &amp; Wellness ในแบบฉบับแอมเวย์ </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 7 พ.ค. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-bold\">คุณภควดี - คุณศรัณย์ วรสุทธิกานนท์</span><br>นักธุรกิจแอมเวย์ระดับเพชรบริหารสองผู้สถาปนา <br>และ <span class=\"text-success f-bold\">คุณรัฐธีร์ ชาญชินปวิณณัช - คุณนิยุตรัตน์ จามพันธ์</span><br>นักธุรกิจแอมเวย์ระดับมงกุฎทูต </p></div></div>", 1)
const _hoisted_219 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_44,
  class: "flag-icon-8"
}, null, -1)
const _hoisted_220 = /*#__PURE__*/_createElementVNode("div", { class: "flag-icon-detail flag-icon-8-detail" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "9 พ.ค. 65")
], -1)
const _hoisted_221 = /*#__PURE__*/_createElementVNode("div", { class: "act-station-end-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_45,
    class: "flag-icon-9"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "flag-icon-detail flag-icon-9-detail" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "16 พ.ค. 65")
  ])
], -1)
const _hoisted_222 = [
  _hoisted_221
]
const _hoisted_223 = /*#__PURE__*/_createElementVNode("div", { class: "act-station-end-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_46,
    class: "flag-icon-10"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "flag-icon-detail flag-icon-10-detail" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "สัปดาห์ที่ 10 และผลรางวัลชนะเลิศ")
  ])
], -1)
const _hoisted_224 = [
  _hoisted_223
]
const _hoisted_225 = { class: "act-corner-end" }
const _hoisted_226 = /*#__PURE__*/_createElementVNode("div", { class: "schedule" }, [
  /*#__PURE__*/_createElementVNode("p", null, "28 พ.ค. 65")
], -1)
const _hoisted_227 = /*#__PURE__*/_createElementVNode("p", null, "28 พ.ค. 65", -1)
const _hoisted_228 = [
  _hoisted_227
]
const _hoisted_229 = { class: "thumbnail-checkpoint" }
const _hoisted_230 = { class: "thumbnail" }
const _hoisted_231 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "act-mark"
}, null, -1)
const _hoisted_232 = /*#__PURE__*/_createStaticVNode("<div class=\"detail\"><h5 class=\"title\"> Creators Challenge <br>Celebration Day 2022 </h5><div class=\"description\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <b>วันที่ 28 พ.ค. 65 เวลา 13.00-14.30 น.</b><br>โดย <span class=\"text-success f-bold\">คุณทศพร นิษฐานนท์</span><br>ผู้จัดการทั่วไปบริษัทแอมเวย์ ประเทศไทย <br>สัมภาษณ์ความประทับใจ 10 ทีม ที่ได้รับรางวัลชนะเลิศ </p></div></div>", 1)
const _hoisted_233 = /*#__PURE__*/_createElementVNode("div", { class: "act-lind-end" }, null, -1)
const _hoisted_234 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_47,
  class: "go-japan"
}, null, -1)
const _hoisted_235 = { class: "container-activity visible-mobile" }
const _hoisted_236 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 1"),
  /*#__PURE__*/_createElementVNode("p", null, "5 - 11 มี.ค 65")
], -1)
const _hoisted_237 = /*#__PURE__*/_createElementVNode("p", null, "5 - 11 มี.ค 65", -1)
const _hoisted_238 = [
  _hoisted_237
]
const _hoisted_239 = { class: "actm-line actm-line-right" }
const _hoisted_240 = { class: "actm-thumbnail" }
const _hoisted_241 = /*#__PURE__*/_createElementVNode("div", { class: "actm-detail" }, [
  /*#__PURE__*/_createElementVNode("h6", null, [
    /*#__PURE__*/_createTextVNode(" เรียนรู้การสร้างแบรนด์ Health & Wellness "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("อย่างไรให้น่าสนใจแบบคุณ ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "actm-detail-live" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_34,
      class: "icon_live"
    }),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" รับชมการถ่ายทอดสด : "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("b", null, "วันที่ 5 มี.ค. 65 เวลา 13.00-15.00 น."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("โดยดิจิทัลโค้ชโซอี้ "),
      /*#__PURE__*/_createElementVNode("span", { class: "f-bold text-success" }, "ภญ.โสภา พิมพ์สิริพานิชย์")
    ])
  ])
], -1)
const _hoisted_242 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 2"),
  /*#__PURE__*/_createElementVNode("p", null, "12 - 18 มี.ค 65")
], -1)
const _hoisted_243 = /*#__PURE__*/_createElementVNode("p", null, "12 - 18 มี.ค 65", -1)
const _hoisted_244 = [
  _hoisted_243
]
const _hoisted_245 = { class: "actm-line actm-line-left" }
const _hoisted_246 = { class: "actm-thumbnail" }
const _hoisted_247 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "actm-mark"
}, null, -1)
const _hoisted_248 = /*#__PURE__*/_createStaticVNode("<div class=\"actm-detail\"><h6> เรียนรู้การเขียนคอนเทนต์ Health &amp; Wellness <br>อย่างไรให้โดนใจ และเทคนิคการขายแบบไม่ขาย </h6><div class=\"actm-detail-live\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <br><b>วันที่ 12 มี.ค. 65 เวลา 13.00-15.00 น.</b><br>โดยดิจิทัลโค้ชโซอี้ <span class=\"f-bold text-success\">ภญ.โสภา พิมพ์สิริพานิชย์</span></p></div></div><div class=\"actm-line actm-line-right\"><img src=\"" + _imports_35 + "\" class=\"actm-flag actm-flag-1\"><div class=\"actm-flag-detail actm-flag-detail-1\"><h5>ประกาศผล</h5><p class=\"text-danger\">21 มี.ค. 65</p></div></div><img src=\"" + _imports_29 + "\" class=\"actm-glass-1\">", 3)
const _hoisted_251 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 3"),
  /*#__PURE__*/_createElementVNode("p", null, "19 - 25 มี.ค 65")
], -1)
const _hoisted_252 = /*#__PURE__*/_createElementVNode("p", null, "19 - 25 มี.ค 65", -1)
const _hoisted_253 = [
  _hoisted_252
]
const _hoisted_254 = { class: "actm-line actm-line-left" }
const _hoisted_255 = { class: "actm-thumbnail left" }
const _hoisted_256 = { class: "actm-thumbnail right" }
const _hoisted_257 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "actm-mark"
}, null, -1)
const _hoisted_258 = /*#__PURE__*/_createStaticVNode("<div class=\"actm-detail\"><h6> การสร้างเพอร์ซันนัล แบรนดิง <br>จะช่วยให้ทำธุรกิจแอมเวย์ง่ายขึ้นอย่างไร? </h6><div class=\"actm-detail-live\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <br><b>วันที่ 20 มี.ค. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-bold\">นพ.ศวัสพล คูณชัยพานิชย์ - ภญ.ณัฐนันท์ งานเลิศ</span> นักธุรกิจแอมเวย์ระดับเพชรสองผู้สถาปนา และ <span class=\"text-success f-bold\">คุณปัญจพล จุรีเกษ - คุณภารดี ปิยนันทวารินทร์</span> นักธุรกิจแอมเวย์ระดับเพชรคู่ </p></div></div><div class=\"actm-line actm-line-right\"><img src=\"" + _imports_37 + "\" class=\"actm-flag actm-flag-2\"><div class=\"actm-flag-detail actm-flag-detail-2\"><h5>ประกาศผล</h5><p class=\"text-danger\">28 มี.ค. 65</p></div></div><img src=\"" + _imports_27 + "\" class=\"actm-dot-1\">", 3)
const _hoisted_261 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 4"),
  /*#__PURE__*/_createElementVNode("p", null, "26 มี.ค - 1 เม.ย. 65")
], -1)
const _hoisted_262 = /*#__PURE__*/_createElementVNode("p", null, "26 มี.ค - 1 เม.ย. 65", -1)
const _hoisted_263 = [
  _hoisted_262
]
const _hoisted_264 = { class: "actm-line actm-line-left" }
const _hoisted_265 = { class: "actm-thumbnail left" }
const _hoisted_266 = { class: "actm-thumbnail right" }
const _hoisted_267 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "actm-mark"
}, null, -1)
const _hoisted_268 = /*#__PURE__*/_createStaticVNode("<div class=\"actm-detail\"><h6> ร่วมค้นหาแรงบันดาลใจ Health &amp; Wellness <br>ในการทำคอนเทนต์สุขภาพกับตัวจริง </h6><div class=\"actm-detail-live\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <br><b>วันที่ 26 มี.ค. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-bold\">คุณพลวัต วิทยรุ่งโรจน์</span> และ <span class=\"text-success f-bold\">คุณพิมพ์อร โมกขะสมิต</span></p></div></div><div class=\"actm-line actm-line-right\"><img src=\"" + _imports_39 + "\" class=\"actm-flag actm-flag-3\"><div class=\"actm-flag-detail actm-flag-detail-3\"><h5>ประกาศผล</h5><p class=\"text-danger\">4 เม.ย. 65</p></div></div><img src=\"" + _imports_28 + "\" class=\"actm-glass-3\">", 3)
const _hoisted_271 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 5"),
  /*#__PURE__*/_createElementVNode("p", null, "02 - 08 เม.ย 65")
], -1)
const _hoisted_272 = /*#__PURE__*/_createElementVNode("p", null, "02 - 08 เม.ย 65", -1)
const _hoisted_273 = [
  _hoisted_272
]
const _hoisted_274 = { class: "actm-line actm-line-left" }
const _hoisted_275 = { class: "actm-thumbnail left" }
const _hoisted_276 = { class: "actm-thumbnail right" }
const _hoisted_277 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "actm-mark"
}, null, -1)
const _hoisted_278 = /*#__PURE__*/_createStaticVNode("<div class=\"actm-detail\"><h6> นำเสนอคอนเทนต์ผลิตภัณฑ์นิวทริไลท์ ผ่านการขาย <br>แบบไม่ขายอย่างไร ให้น่าสนใจบนโซเชียลมีเดีย </h6><div class=\"actm-detail-live\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <br><b>วันที่ 2 เม.ย. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-bold\">คุณพรพิมล ผู้พัฒน์ - คุณเจตน์กวิน โพธิ์ใบกุล</span> นักธุรกิจแอมเวย์ระดับเพชรบริหาร และ <br><span class=\"text-success f-bold\">คุณณรุส-คุณสมรศรี มหัคฆพงศ์</span> นักธุรกิจแอมเวย์ระดับเพชรคู่ </p></div></div><div class=\"actm-line actm-line-right\"><img src=\"" + _imports_40 + "\" class=\"actm-flag actm-flag-4\"><div class=\"actm-flag-detail actm-flag-detail-4\"><h5>ประกาศผล</h5><p class=\"text-danger\">11 เม.ย. 65</p></div></div>", 2)
const _hoisted_280 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 6"),
  /*#__PURE__*/_createElementVNode("p", null, "09 - 15 เม.ย 65")
], -1)
const _hoisted_281 = /*#__PURE__*/_createElementVNode("p", null, "09 - 15 เม.ย 65", -1)
const _hoisted_282 = [
  _hoisted_281
]
const _hoisted_283 = { class: "actm-line actm-line-left" }
const _hoisted_284 = { class: "actm-thumbnail left" }
const _hoisted_285 = { class: "actm-thumbnail right" }
const _hoisted_286 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "actm-mark"
}, null, -1)
const _hoisted_287 = /*#__PURE__*/_createStaticVNode("<div class=\"actm-detail\"><h6> เรียนรู้กับแอมเวย์ครีเอเตอร์ ในหัวข้อการแต่งภาพสไตล์ <br>Health &amp; Wellness ด้วยแอปพลิเคชัน ยอดฮิต </h6><div class=\"actm-detail-live\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <br><b>วันที่ 9 เม.ย. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-bold\">คุณนิชกานต์ อ้วนเจริญ</span> นักธุรกิจแอมเวย์ระดับแพลตินัม และ <span class=\"text-success f-bold\">คุณชิดชนก อินทะกาล - คุณณัฐพงศ์ เสรีนนท์ชัย</span><br>นักธุรกิจแอมเวย์ระดับแพลตินัมสองผู้สถาปนา </p></div></div><div class=\"actm-line actm-line-right\"><img src=\"" + _imports_41 + "\" class=\"actm-flag actm-flag-5\"><div class=\"actm-flag-detail actm-flag-detail-5\"><h5>ประกาศผล</h5><p class=\"text-danger\">18 เม.ย. 65</p></div></div>", 2)
const _hoisted_289 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 7"),
  /*#__PURE__*/_createElementVNode("p", null, "16 - 22 เม.ย 65")
], -1)
const _hoisted_290 = /*#__PURE__*/_createElementVNode("p", null, "16 - 22 เม.ย 65", -1)
const _hoisted_291 = [
  _hoisted_290
]
const _hoisted_292 = { class: "actm-line actm-line-left" }
const _hoisted_293 = { class: "actm-thumbnail" }
const _hoisted_294 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "actm-mark"
}, null, -1)
const _hoisted_295 = /*#__PURE__*/_createStaticVNode("<div class=\"actm-detail\"><h6> เรียนรู้การสร้างคอมมิวนิตีออนไลน์ <br>Health &amp; Wellness ในแบบฉบับของคุณ </h6><div class=\"actm-detail-live\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <br><b>วันที่ 16 เม.ย. 65 เวลา 13.00-15.00 น.</b><br>โดยดิจิทัลโค้ช <span class=\"text-success f-bold\">ครูทิป คุณมัณฑิตา จินดา</span></p></div></div><div class=\"actm-line actm-line-right\"><img src=\"" + _imports_42 + "\" class=\"actm-flag actm-flag-6\"><div class=\"actm-flag-detail actm-flag-detail-6\"><h5>ประกาศผล</h5><p class=\"text-danger\">25 เม.ย. 65</p></div></div><img src=\"" + _imports_27 + "\" class=\"actm-dot-1\">", 3)
const _hoisted_298 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 8"),
  /*#__PURE__*/_createElementVNode("p", null, "23 - 29 เม.ย 65")
], -1)
const _hoisted_299 = /*#__PURE__*/_createElementVNode("p", null, "23 - 29 เม.ย 65", -1)
const _hoisted_300 = [
  _hoisted_299
]
const _hoisted_301 = { class: "actm-line actm-line-left" }
const _hoisted_302 = { class: "actm-thumbnail left" }
const _hoisted_303 = { class: "actm-thumbnail right" }
const _hoisted_304 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "actm-mark"
}, null, -1)
const _hoisted_305 = /*#__PURE__*/_createStaticVNode("<div class=\"actm-detail\"><h6> เรียนรู้การสร้างคอมมิวนิตีออนไลน์ <br>Health &amp; Wellness สไตล์แอมเวย์ </h6><div class=\"actm-detail-live\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <br><b>วันที่ 23 เม.ย. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-bold\">คุณจิรศักดิ์ อั้นใจเอก - คุณชนากานต์ ปานแก้ว</span><br>นักธุรกิจแอมเวย์ระดับเพชร และ <span class=\"text-success f-bold\">คุณพีระ พันธุ์พิพัฒน์ - คุณชนัดดา ปรีชาหาญ</span> นักธุรกิจแอมเวย์ระดับเพชรบริหารสองผู้สถาปนา </p></div></div><div class=\"actm-line actm-line-right\"><img src=\"" + _imports_43 + "\" class=\"actm-flag actm-flag-7\"><div class=\"actm-flag-detail actm-flag-detail-7\"><h5>ประกาศผล</h5><p class=\"text-danger\">2 พ.ค. 65</p></div></div>", 2)
const _hoisted_307 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 9"),
  /*#__PURE__*/_createElementVNode("p", null, "30 เม.ย - 06 พ.ค 65")
], -1)
const _hoisted_308 = /*#__PURE__*/_createElementVNode("p", null, "30 เม.ย - 06 พ.ค 65", -1)
const _hoisted_309 = [
  _hoisted_308
]
const _hoisted_310 = { class: "actm-line actm-line-left" }
const _hoisted_311 = { class: "actm-thumbnail" }
const _hoisted_312 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "actm-mark"
}, null, -1)
const _hoisted_313 = /*#__PURE__*/_createStaticVNode("<div class=\"actm-detail\"><h6> ข้อมูลในโซเชียลมีเดีย สามารถนำมาปรับใช้ <br>กับการทำคอนเทนต์ ของเราได้อย่างไร? </h6><div class=\"actm-detail-live\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <br><b>วันที่ 1 พ.ค. 65 เวลา 13.00-14.00 น.</b><br>โดยดิจิทัลโค้ช <span class=\"text-success f-bold\">คุณพุทธศักดิ์ ตันติสุทธิเวท</span><br>Data Research Manager บริษัท WISESIGHT </p></div></div><div class=\"actm-line actm-line-right\"><img src=\"" + _imports_44 + "\" class=\"actm-flag actm-flag-8\"><div class=\"actm-flag-detail actm-flag-detail-8\"><h5>ประกาศผล</h5><p class=\"text-danger\">9 พ.ค. 65</p></div></div><img src=\"" + _imports_28 + "\" class=\"actm-glass-3\">", 3)
const _hoisted_316 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 10"),
  /*#__PURE__*/_createElementVNode("p", null, "07 - 13 พ.ค 65")
], -1)
const _hoisted_317 = /*#__PURE__*/_createElementVNode("p", null, "07 - 13 พ.ค 65", -1)
const _hoisted_318 = [
  _hoisted_317
]
const _hoisted_319 = { class: "actm-line actm-line-left" }
const _hoisted_320 = { class: "actm-thumbnail left" }
const _hoisted_321 = { class: "actm-thumbnail right" }
const _hoisted_322 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "actm-mark"
}, null, -1)
const _hoisted_323 = /*#__PURE__*/_createStaticVNode("<div class=\"actm-detail\"><h6> เรื่องราวความสำเร็จของการทำคอมมิวนิตี <br>Health &amp; Wellness ในแบบฉบับแอมเวย์ </h6><div class=\"actm-detail-live\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <br><b>วันที่ 7 พ.ค. 65 เวลา 13.00-15.00 น.</b><br>โดย <span class=\"text-success f-bold\">คุณภควดี - คุณศรัณย์ วรสุทธิกานนท์</span> นักธุรกิจแอมเวย์ระดับเพชรบริหารสองผู้สถาปนา และ <br><span class=\"text-success f-bold\">คุณรัฐธีร์ ชาญชินปวิณณัช - คุณนิยุตรัตน์ จามพันธ์</span><br>นักธุรกิจแอมเวย์ระดับมงกุฎทูต </p></div></div><img src=\"" + _imports_27 + "\" class=\"actm-dot-end\">", 2)
const _hoisted_325 = /*#__PURE__*/_createElementVNode("div", { class: "actm-line actm-line-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_45,
    class: "actm-flag actm-flag-9"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "actm-flag-detail actm-flag-detail-9" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "16 พ.ค. 65")
  ])
], -1)
const _hoisted_326 = [
  _hoisted_325
]
const _hoisted_327 = /*#__PURE__*/_createElementVNode("div", { class: "actm-day" }, [
  /*#__PURE__*/_createElementVNode("p", null, "28 พ.ค. 65")
], -1)
const _hoisted_328 = /*#__PURE__*/_createElementVNode("p", null, "28 พ.ค. 65", -1)
const _hoisted_329 = [
  _hoisted_328
]
const _hoisted_330 = /*#__PURE__*/_createElementVNode("div", { class: "actm-line actm-line-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_46,
    class: "actm-flag actm-flag-10"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "actm-flag-detail actm-flag-detail-10" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "ประกาศผล"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "สัปดาห์ที่ 10 และผลรางวัลชนะเลิศ")
  ])
], -1)
const _hoisted_331 = { class: "actm-line actm-line-end actm-line-right" }
const _hoisted_332 = { class: "actm-thumbnail" }
const _hoisted_333 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  class: "actm-mark"
}, null, -1)
const _hoisted_334 = /*#__PURE__*/_createStaticVNode("<div class=\"actm-detail\"><h6> Creators Challenge <br>Celebration Day 2022 </h6><div class=\"actm-detail-live\"><img src=\"" + _imports_34 + "\" class=\"icon_live\"><p> รับชมการถ่ายทอดสด : <br><b>วันที่ 28 พ.ค. 65 เวลา 13.00-14.30 น.</b><br>โดย <span class=\"text-success f-bold\">คุณทศพร นิษฐานนท์</span><br>ผู้จัดการทั่วไปบริษัทแอมเวย์ ประเทศไทย <br>สัมภาษณ์ความประทับใจ 10 ทีม ที่ได้รับรางวัลชนะเลิศ </p></div></div><div class=\"actm-lind-end\"></div>", 2)
const _hoisted_336 = /*#__PURE__*/_createElementVNode("div", { class: "actm-go-japan" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_47,
    class: ""
  })
], -1)
const _hoisted_337 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_27 + "\" class=\"bg-dot dot-bottom-left visible-desktop\"><img src=\"" + _imports_27 + "\" class=\"bg-dot dot-bottom-right visible-desktop\"><img src=\"" + _imports_27 + "\" class=\"bg-dot dot-center-right visible-desktop\"><img src=\"" + _imports_28 + "\" class=\"grass-bottom-right visible-desktop\"><img src=\"" + _imports_48 + "\" class=\"act-mountain\"><img src=\"" + _imports_49 + "\" class=\"actm-mountain\">", 6)
const _hoisted_343 = { class: "container-act-table" }
const _hoisted_344 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"act-table\"><div class=\"act-table-header\"><img src=\"" + _imports_50 + "\" class=\"trophy\"><h4> ตารางการแข่งขันและ <br>ประกาศผลรางวัลรายสัปดาห์ </h4></div><div class=\"table\"><div class=\"table-header\"><div class=\"table-header-weak\"><img src=\"" + _imports_51 + "\" alt=\"calendar\"><h5>สัปดาห์</h5></div><div class=\"table-header-announce\"><img src=\"" + _imports_52 + "\" alt=\"calendar\"><h5>ประกาศรางวัลรายสัปดาห์</h5></div></div><div class=\"table-body\"><div class=\"table-body-item\"><div class=\"table-body-weak\">สัปดาห์ที่ 1</div><div class=\"table-body-detail\">05 - 11 มี.ค 65</div><div class=\"table-body-announce\">21 มี.ค 65</div></div><div class=\"table-body-item\"><div class=\"table-body-weak\">สัปดาห์ที่ 2</div><div class=\"table-body-detail\">12 - 18 มี.ค 65</div><div class=\"table-body-announce\">28 มี.ค. 65</div></div><div class=\"table-body-item\"><div class=\"table-body-weak\">สัปดาห์ที่ 3</div><div class=\"table-body-detail\">19 - 25 มี.ค 65</div><div class=\"table-body-announce\">4 เม.ย. 65</div></div><div class=\"table-body-item\"><div class=\"table-body-weak\">สัปดาห์ที่ 4</div><div class=\"table-body-detail\">26 มี.ค - 01 เม.ย 65</div><div class=\"table-body-announce\">11 เม.ย. 65</div></div><div class=\"table-body-item\"><div class=\"table-body-weak\">สัปดาห์ที่ 5</div><div class=\"table-body-detail\">02 - 08 เม.ย 65</div><div class=\"table-body-announce\">18 เม.ย. 65</div></div><div class=\"table-body-item\"><div class=\"table-body-weak\">สัปดาห์ที่ 6</div><div class=\"table-body-detail\">09 - 15 เม.ย 65</div><div class=\"table-body-announce\">25 เม.ย. 65</div></div><div class=\"table-body-item\"><div class=\"table-body-weak\">สัปดาห์ที่ 7</div><div class=\"table-body-detail\">16 - 22 เม.ย 65</div><div class=\"table-body-announce\">2 พ.ค. 65</div></div><div class=\"table-body-item\"><div class=\"table-body-weak\">สัปดาห์ที่ 8</div><div class=\"table-body-detail\">23 - 29 เม.ย 65</div><div class=\"table-body-announce\">9 พ.ค. 65</div></div><div class=\"table-body-item\"><div class=\"table-body-weak\">สัปดาห์ที่ 9</div><div class=\"table-body-detail\">30 เม.ย - 06 พ.ค 65</div><div class=\"table-body-announce\">16 พ.ค. 65</div></div><div class=\"table-body-item\"><div class=\"table-body-weak\">สัปดาห์ที่ 10</div><div class=\"table-body-detail\">07 - 13 พ.ค 65</div><div class=\"table-body-announce\">23 พ.ค. 65</div></div></div></div><div class=\"summary\"><img src=\"" + _imports_30 + "\" class=\"mountain-left\"><img src=\"" + _imports_32 + "\" class=\"mountain-right\"><img src=\"" + _imports_53 + "\" class=\"reward\"><div class=\"detail\"><div class=\"summary-left\"><p style=\"color:red;font-weight:bold;font-size:20px;margin-bottom:5px;\">ประกาศผลคะแนนรวมรอบชิงชนะเลิศ* 23 พ.ค. 65</p><p>*คะแนนรวมรอบชิงชนะเลิศ คือ คะแนนที่คุณทำได้ตลอด 10 สัปดาห์ + ชุดเริ่มต้นควบคุมน้ำหนักบอดี้คีย์</p><p>+ การเข้าร่วม Facebook Close Group รวมผลคน FitFirmFun by Nutrilite และ Creators Thailand Community</p></div></div></div></div></div>", 1)
const _hoisted_345 = /*#__PURE__*/_createElementVNode("h5", null, "ท่านสามารถติดต่อรับของวัลได้ที่แอมเวย์ช็อป", -1)
const _hoisted_346 = /*#__PURE__*/_createElementVNode("h6", null, "หลังประกาศผลรางวัลในแต่ละสัปดาห์โดยท่านจะต้องลงทะเบียนเพื่อแจ้งแอมเวย์ช็อปที่จะรับของรางวัล", -1)
const _hoisted_347 = [
  _hoisted_345,
  _hoisted_346
]
const _hoisted_348 = /*#__PURE__*/_createElementVNode("div", { class: "actm-table-mountain" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "ท่านสามารถติดต่อรับของวัลได้ที่แอมเวย์ช็อป"),
  /*#__PURE__*/_createElementVNode("h6", null, "หลังประกาศผลรางวัลในแต่ละสัปดาห์โดยท่านจะต้องลงทะเบียนเพื่อแจ้งแอมเวย์ช็อปที่จะรับของรางวัล")
], -1)
const _hoisted_349 = /*#__PURE__*/_createStaticVNode("<section class=\"footer\"><div class=\"container\"><div class=\"row mx-0\"><div class=\"footer-logo\"><img src=\"" + _imports_54 + "\" height=\"40px\"></div><div class=\"footer-address\"> บริษัท แอมเวย์ (ประเทศไทย) จำกัด <br>1199/1 ถนนรามคำแหง แขวงหัวหมาก เขตบางกะปิ กรุงเทพ ฯ 10240 </div><div class=\"footer-call\"><div class=\"footer-call-text\">ต้องการความช่วยเหลือ ?</div><div class=\"footer-call-phone\"><img src=\"" + _imports_55 + "\"><a href=\"tel:+0-2725-8000\">0-2725-8000</a></div></div><div class=\"copy-right\">Copyright 2022, Amway (Thailand) Ltd,.</div></div></div></section>", 1)
const _hoisted_350 = {
  key: 2,
  class: "act-modal-dim d-none",
  id: "detail-modal-1"
}
const _hoisted_351 = { class: "act-modal-container" }
const _hoisted_352 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_353 = [
  _hoisted_352
]
const _hoisted_354 = { class: "act-modal-header-m" }
const _hoisted_355 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_356 = [
  _hoisted_355
]
const _hoisted_357 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_358 = { class: "relative w-100" }
const _hoisted_359 = /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 1", -1)
const _hoisted_360 = /*#__PURE__*/_createElementVNode("p", null, "5 - 11 มี.ค. 65", -1)
const _hoisted_361 = [
  _hoisted_359,
  _hoisted_360
]
const _hoisted_362 = { class: "scroll-modal" }
const _hoisted_363 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createTextVNode(" Get to know How to create your personal branding "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("เรียนรู้การสร้างแบรนด์ Health and Wellness อย่างไรให้น่าสนใจแบบคุณ? ")
  ])
], -1)
const _hoisted_364 = { class: "act-modal-detail" }
const _hoisted_365 = { class: "act-modal-content act-modal-thumbnail" }
const _hoisted_366 = { class: "thumbnail-box" }
const _hoisted_367 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "ภญ.โสภา พิมพ์สิริพานิชย์", -1)
const _hoisted_368 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "ดิจิทัลโค้ชโซอี้", -1)
const _hoisted_369 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-content\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\"> วันที่ 5 มี.ค. 65 เวลา 13.00-15.00 น. <br><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </p></div><ul><li>คอมมิวนิตีที่ได้รับความนิยม เพื่อสร้าง เพอร์ซันนัล แบรนดิง</li><li>4 ขั้นตอน การสร้างตัวตนบนโลกออนไลน์</li><li>วิธีการเริ่มต้น และเทคนิคการค้นหาตัวตนของตัวเอง (Brand DNA)</li><li>กลยุทธ์นำเสนอภาพตัวตนของคุณให้ชัด และเป็นที่จดจำบนโลกออนไลน์</li></ul><a href=\"https://studioabothai.com/event/303\" class=\"link text-success\">https://studioabothai.com/event/303</a></div>", 1)
const _hoisted_370 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-greencontainer\"><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 1</h6></div><div class=\"detail\"><p> เรียนรู้มาตราฐานการสื่อสารแบบดิจิทัล Digital Communication Standards (DCS) <br>เพื่อการทำธุรกิจแอมเวย์บนสื่อออนไลน์ได้ง่ายขึ้น <br></p><a href=\"https://studioabothai.com/pathway-summary/288\" class=\"link text-success\">https://studioabothai.com/pathway-summary/288</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 2</h6></div><div class=\"detail\"><p>สร้างแบรนด์อย่างไร ให้น่าสนใจในแบบของคุณ ?</p><a href=\"https://studioabothai.com/pathway-summary/289\" class=\"link text-success\">https://studioabothai.com/pathway-summary/289</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 3</h6></div><div class=\"detail\"><p>BodyKey Clinic เคลียร์ชัด เรื่องผลิตภัณฑ์บอดี้ คีย์</p><a href=\"https://studioabothai.com/pathway-summary/304\" class=\"link text-success\">https://studioabothai.com/pathway-summary/304</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div></div><div class=\"act-modal-greencontainer\"><div class=\"act-modal-product w-100\"><div class=\"product-image\"><h6>ทำคอนเทนต์ Health and Wellness</h6><img src=\"" + _imports_59 + "\" class=\"act-modal-product-img\"></div><div class=\"product-detail\"><div class=\"product-detail-text\"><p class=\"f-bold\">ผลิตภัณฑ์ Tie-in เลือกจาก</p><p> นิวทริไลท์ โปรตีน รสชาติใดก็ได้, นิวทริไลท์ ดับเบิ้ล เอ็กซ์ ไฟโตเบลนด์ และนิวทริไลท์ น้ำมันปลา </p><p class=\"mt-16\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"actm-post-point-text\"><span class=\"text-success\">รับ 3 คะแนน</span> เมื่อโพสต์ครบ 3 โพสต์ </span></p></div></div></div><img src=\"" + _imports_60 + "\" class=\"all-social\"></div>", 2)
const _hoisted_372 = {
  key: 3,
  class: "act-modal-dim d-none",
  id: "detail-modal-2"
}
const _hoisted_373 = { class: "act-modal-container" }
const _hoisted_374 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_375 = [
  _hoisted_374
]
const _hoisted_376 = { class: "act-modal-header-m" }
const _hoisted_377 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_378 = [
  _hoisted_377
]
const _hoisted_379 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_380 = { class: "relative w-100" }
const _hoisted_381 = /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 2", -1)
const _hoisted_382 = /*#__PURE__*/_createElementVNode("p", null, "12 - 18 มี.ค 65", -1)
const _hoisted_383 = [
  _hoisted_381,
  _hoisted_382
]
const _hoisted_384 = { class: "scroll-modal" }
const _hoisted_385 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createTextVNode(" Get to know How to create Health & Wellness Contents "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("เรียนรู้การเขียนคอนเทนต์ Health & Wellness อย่างไรให้โดนใจ และเทคนิคการขายแบบไม่ขาย ")
  ])
], -1)
const _hoisted_386 = { class: "act-modal-detail" }
const _hoisted_387 = { class: "act-modal-content act-modal-thumbnail" }
const _hoisted_388 = { class: "thumbnail-box" }
const _hoisted_389 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "ภญ.โสภา พิมพ์สิริพานิชย์", -1)
const _hoisted_390 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "ดิจิทัลโค้ชโซอี้", -1)
const _hoisted_391 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-content\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\"> วันที่ 12 มี.ค. 65 เวลา 13.00-15.00 น. <br><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </p></div><ul><li>การเล่าเรื่อง (Story Telling) และเทคนิคการเล่าเรื่อง ให้น่าสนใจบนโลกออนไลน์</li><li>ขั้นตอนการโปรโมตตัวเองบนโลกออนไลน์ สิ่งสำคัญคือการทำให้ผู้คนบนโลกออนไลน์มาติดตาม</li><li>เทคนิคการขายแบบไม่ขายผ่านหน้าเฟซบุ๊กส่วนตัว</li><li>กลยุทธ์การ Live เพื่อให้คอนเทนต์ของคุณเข้าถึงคนจำนวนมาก</li></ul><a href=\"https://studioabothai.com/event/304\" class=\"link text-success\">https://studioabothai.com/event/304</a></div>", 1)
const _hoisted_392 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-wrap-content\"><div class=\"act-modal-greencontainer\"><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 1</h6></div><div class=\"detail\"><p>คอนเทนต์ผลิตภัณฑ์นิวทริไลท์ และข้อกำหนดการโฆษณาผลิตภัณฑ์เสริมอาหารบนโลกออนไลน์</p><a href=\"https://studioabothai.com/pathway-summary/290\" class=\"link text-success\">https://studioabothai.com/pathway-summary/290</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 2</h6></div><div class=\"detail\"><p>กลยุทธ์การใช้เฟซบุ๊ก และอินสตาแกรม</p><a href=\"https://studioabothai.com/pathway-summary/291\" class=\"link text-success\">https://studioabothai.com/pathway-summary/291</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 3</h6></div><div class=\"detail\"><p>เขียนคอนเทนต์อย่างไรให้โดนใจ และ 6 ขั้นตอนการขาย</p><a href=\"https://studioabothai.com/pathway-summary/292\" class=\"link text-success\">https://studioabothai.com/pathway-summary/292</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 4</h6></div><div class=\"detail\"><p>BODYKEY TALK คุยชัด เจาะลึก ควบคุมอาหารถูกหลัก ลดน้ำหนักได้ยั่งยืน</p><a href=\"https://studioabothai.com/pathway-summary/305\" class=\"link text-success\">https://studioabothai.com/pathway-summary/305</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div></div><div class=\"act-modal-greencontainer\"><div class=\"act-modal-product w-100\"><div class=\"product-image\"><h6>ทำคอนเทนต์ Health and Wellness</h6><img src=\"" + _imports_61 + "\" class=\"act-modal-product-img\"></div><div class=\"product-detail\"><div class=\"product-detail-text\"><p class=\"f-bold\">ผลิตภัณฑ์ Tie-in เลือกจาก</p><p> บอดี้คีย์ บาย นิวทริไลท์ รสชาติใดก็ได้, นิวทริไลท์ กรีน-ที พลัส, นิวทริไลท์ แคล โลว์ และนิวทริไลท์ ซีแอลเอ 500 จากน้ำมันดอกคำฝอย </p><p class=\"mt-16\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"actm-post-point-text\"><span class=\"text-success\">รับ 3 คะแนน</span> เมื่อโพสต์ครบ 3 โพสต์ </span></p></div></div></div><img src=\"" + _imports_60 + "\" class=\"all-social\"></div></div>", 1)
const _hoisted_393 = {
  key: 4,
  class: "act-modal-dim d-none",
  id: "detail-modal-3"
}
const _hoisted_394 = { class: "act-modal-container" }
const _hoisted_395 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_396 = [
  _hoisted_395
]
const _hoisted_397 = { class: "act-modal-header-m" }
const _hoisted_398 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_399 = [
  _hoisted_398
]
const _hoisted_400 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_401 = { class: "relative w-100" }
const _hoisted_402 = /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 3", -1)
const _hoisted_403 = /*#__PURE__*/_createElementVNode("p", null, "19 - 25 มี.ค. 65", -1)
const _hoisted_404 = [
  _hoisted_402,
  _hoisted_403
]
const _hoisted_405 = { class: "scroll-modal" }
const _hoisted_406 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createTextVNode(" Start social selling for Amway Business "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("การสร้างเพอร์ซันนัล แบรนดิงจะช่วยให้ทำธุรกิจแอมเวย์ง่ายขึ้นอย่างไร? ")
  ])
], -1)
const _hoisted_407 = { class: "act-modal-detail" }
const _hoisted_408 = { class: "act-modal-content act-modal-thumbnail" }
const _hoisted_409 = { class: "thumbnail-box" }
const _hoisted_410 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, [
  /*#__PURE__*/_createTextVNode(" นพ.ศวัสพล คูณชัยพานิชย์ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("- ภญ.ณัฐนันท์ งานเลิศ ")
], -1)
const _hoisted_411 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "นักธุรกิจแอมเวย์ระดับเพชรสองผู้สถาปนา", -1)
const _hoisted_412 = { class: "thumbnail-box" }
const _hoisted_413 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, [
  /*#__PURE__*/_createTextVNode(" คุณปัญจพล จุรีเกษ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("- คุณภารดี ปิยนันทวารินทร์ ")
], -1)
const _hoisted_414 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "นักธุรกิจแอมเวย์ระดับเพชรคู่", -1)
const _hoisted_415 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-content\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\"> วันที่ 20 มี.ค. 65 เวลา 13.00-15.00 น. <br><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </p></div><ul><li>การสร้างเพอร์ซันนัล แบรนดิง ในแบบฉบับของนักธุรกิจแอมเวย์</li><li>ขั้นตอนการสร้างธุรกิจจากการดูแลสุขภาพทำอย่างไรให้โดดเด่นและแตกต่าง</li><li>แนวทางการสร้างเพอร์ซันนัล แบรนดิง ร่วมกับผลิตภัณฑ์ กลุ่มนิวทริไลท์</li></ul><a href=\"https://studioabothai.com/event/305\" class=\"link text-success\">https://studioabothai.com/event/305</a></div>", 1)
const _hoisted_416 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-greencontainer\"><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 1</h6></div><div class=\"detail\"><p>6 เทคนิคการขาย และการสปอนเซอร์ สไตล์แอมเวย์ 1</p><a href=\"https://studioabothai.com/pathway-summary/293\" class=\"link text-success\">https://studioabothai.com/pathway-summary/293</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 2</h6></div><div class=\"detail\"><p>ไขมันในเลือด กับ สุขภาพถ้าเข้าใจไม่ต้องกลัว</p><a href=\"https://studioabothai.com/pathway-summary/306\" class=\"link text-success\">https://studioabothai.com/pathway-summary/306</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div></div><div class=\"act-modal-greencontainer\"><div class=\"act-modal-product w-100\"><div class=\"product-image\"><h6>ทำคอนเทนต์ Health and Wellness</h6><img src=\"" + _imports_62 + "\" class=\"act-modal-product-img\"></div><div class=\"product-detail\"><div class=\"product-detail-text\"><p class=\"f-bold\">ผลิตภัณฑ์ Tie-in เลือกจาก</p><p>ผลิตภัณฑ์ใดก็ได้ในกลุ่มเอ็น บาย นิวทริไลท์</p><p class=\"mt-16\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"actm-post-point-text\"><span class=\"text-success\">รับ 3 คะแนน</span> เมื่อโพสต์ครบ 3 โพสต์ </span></p></div></div></div><img src=\"" + _imports_60 + "\" class=\"all-social\"></div>", 2)
const _hoisted_418 = {
  key: 5,
  class: "act-modal-dim d-none",
  id: "detail-modal-4"
}
const _hoisted_419 = { class: "act-modal-container" }
const _hoisted_420 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_421 = [
  _hoisted_420
]
const _hoisted_422 = { class: "act-modal-header-m" }
const _hoisted_423 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_424 = [
  _hoisted_423
]
const _hoisted_425 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_426 = { class: "relative w-100" }
const _hoisted_427 = /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 4", -1)
const _hoisted_428 = /*#__PURE__*/_createElementVNode("p", null, "26 มี.ค - 1 เม.ย. 65", -1)
const _hoisted_429 = [
  _hoisted_427,
  _hoisted_428
]
const _hoisted_430 = { class: "scroll-modal" }
const _hoisted_431 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createTextVNode(" Finding your inspirations "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ร่วมค้นหาแรงบันดาลใจ Health & Wellness Creators "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ในการทำคอนเทนต์สุขภาพกับตัวจริง ")
  ])
], -1)
const _hoisted_432 = { class: "act-modal-detail" }
const _hoisted_433 = { class: "act-modal-content act-modal-thumbnail" }
const _hoisted_434 = { class: "thumbnail-box" }
const _hoisted_435 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "คุณพลวัต วิทยรุ่งโรจน์", -1)
const _hoisted_436 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, [
  /*#__PURE__*/_createTextVNode(" เจ้าของ Youtube และ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Facebook Page “NAEFIT” ")
], -1)
const _hoisted_437 = { class: "thumbnail-box" }
const _hoisted_438 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "คุณพิมพ์อร โมกขะสมิต", -1)
const _hoisted_439 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, [
  /*#__PURE__*/_createTextVNode(" เจ้าของ Facebook Page และ"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("IG “CU.Fitgirl” ")
], -1)
const _hoisted_440 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-content\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\"> วันที่ 26 มี.ค. 65 เวลา 13.00-15.00 น. <br><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </p></div><ul><li>สูตรสำเร็จสร้างคอนเทนต์ Health and Wellness ให้ปังบนโซเชียลมีเดีย ใครก็ทำได้</li><li>เทคนิคเนียนๆ Tie-in สินค้าเพื่อดูแลสุขภาพ</li><li>คอนเทนต์ Health and Wellness รูปแบบไหน ช่วยให้คุณเพิ่มยอดผู้ติดตามเพื่อเพิ่มโอกาสทางธุรกิจแอมเวย์</li></ul><a href=\"https://studioabothai.com/event/306\" class=\"link text-success\">https://studioabothai.com/event/306</a></div>", 1)
const _hoisted_441 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-greencontainer\"><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 1</h6></div><div class=\"detail\"><p>6 เทคนิคการขาย และการสปอนเซอร์ สไตล์แอมเวย์ 2</p><a href=\"https://studioabothai.com/pathway-summary/294\" class=\"link text-success\">https://studioabothai.com/pathway-summary/294</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 2</h6></div><div class=\"detail\"><p>ดูแลครบ จบเรื่องโปรตีน</p><a href=\"https://studioabothai.com/pathway-summary/307\" class=\"link text-success\">https://studioabothai.com/pathway-summary/307</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div></div><div class=\"act-modal-greencontainer\"><div class=\"act-modal-product w-100\"><div class=\"product-image\"><h6>ทำคอนเทนต์ Health and Wellness</h6><img src=\"" + _imports_63 + "\" class=\"act-modal-product-img\"></div><div class=\"product-detail\"><div class=\"product-detail-text\"><p class=\"f-bold\">ผลิตภัณฑ์ Tie-in เลือกจาก</p><p>นิวทริไลท์ เฮอร์บัล มิกซ์, นิวทริไลท์ โพรไบโอติก, นิวทริไลท์ โพรไบโอติก ดับเบิ้ลยู และ เอ็น บาย นิวทริไลท์ เอ็น* ชา</p><p class=\"mt-16\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"actm-post-point-text\"><span class=\"text-success\">รับ 3 คะแนน</span> เมื่อโพสต์ครบ 3 โพสต์ </span></p></div></div></div><img src=\"" + _imports_60 + "\" class=\"all-social\"></div>", 2)
const _hoisted_443 = {
  key: 6,
  class: "act-modal-dim d-none",
  id: "detail-modal-5"
}
const _hoisted_444 = { class: "act-modal-container" }
const _hoisted_445 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_446 = [
  _hoisted_445
]
const _hoisted_447 = { class: "act-modal-header-m" }
const _hoisted_448 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_449 = [
  _hoisted_448
]
const _hoisted_450 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_451 = { class: "relative w-100" }
const _hoisted_452 = /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 5", -1)
const _hoisted_453 = /*#__PURE__*/_createElementVNode("p", null, "2 - 8 เม.ย 65", -1)
const _hoisted_454 = [
  _hoisted_452,
  _hoisted_453
]
const _hoisted_455 = { class: "scroll-modal" }
const _hoisted_456 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createTextVNode(" How to create Health& Wellness Contents in Amway style "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("นำเสนอคอนเทนต์ผลิตภัณฑ์นิวทริไลท์ ผ่านการขายแบบไม่ขายอย่างไร "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ให้น่าสนใจบนโซเชียลมีเดีย ")
  ])
], -1)
const _hoisted_457 = { class: "act-modal-detail" }
const _hoisted_458 = { class: "act-modal-content act-modal-thumbnail" }
const _hoisted_459 = { class: "thumbnail-box" }
const _hoisted_460 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, [
  /*#__PURE__*/_createTextVNode(" คุณพรพิมล ผู้พัฒน์ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("- คุณเจตน์กวิน โพธิ์ใบกุล ")
], -1)
const _hoisted_461 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "นักธุรกิจแอมเวย์ระดับเพชรบริหาร", -1)
const _hoisted_462 = { class: "thumbnail-box" }
const _hoisted_463 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "คุณณรุส-คุณสมรศรี มหัคฆพงศ์", -1)
const _hoisted_464 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, " นักธุรกิจแอมเวย์ระดับเพชรคู่ ", -1)
const _hoisted_465 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-content\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\"> วันที่ 2 เม.ย. 65 เวลา 13.00-15.00 น. <br><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </p></div><ul><li>ทำความรู้จักกับลูกค้าบนโซเชียลมีเดีย</li><li>เทคนิคการทำคอนเทนต์ “ขายแบบไม่ขาย”</li><li>เปลี่ยนลูกค้าสู่โอกาสการเป็นนักธุรกิจแอมเวย์</li></ul><a href=\"https://studioabothai.com/event/307\" class=\"link text-success\">https://studioabothai.com/event/307</a></div>", 1)
const _hoisted_466 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-greencontainer\"><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 1</h6></div><div class=\"detail\"><p>หาแรงบันดาลใจในการสร้างคอนเทนต์ Health and Wellness สไตล์แอมเวย์</p><a href=\"https://studioabothai.com/pathway-summary/295\" class=\"link text-success\">https://studioabothai.com/pathway-summary/295</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 2</h6></div><div class=\"detail\"><p>รู้ก่อนได้เปรียบ สารอาหารช่วยควบคุมไขมันในเลือด</p><a href=\"https://studioabothai.com/pathway-summary/308\" class=\"link text-success\">https://studioabothai.com/pathway-summary/308</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div></div><div class=\"act-modal-greencontainer\"><div class=\"act-modal-product w-100\"><div class=\"product-image\"><h6>ทำคอนเทนต์ Health and Wellness</h6><img src=\"" + _imports_64 + "\" class=\"act-modal-product-img\"></div><div class=\"product-detail\"><div class=\"product-detail-text\"><p class=\"f-bold\">ผลิตภัณฑ์ Tie-in เลือกจาก</p><p>นิวทริไลท์ ดับเบิ้ลยู แพ็ค, นิวทริไลท์ คอนเซ็นเทรต แพ็ค, นิวทริไลท์ ไวทัล แพ็ค</p><p class=\"mt-16\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"actm-post-point-text\"><span class=\"text-success\">รับ 3 คะแนน</span> เมื่อโพสต์ครบ 3 โพสต์ </span></p></div></div></div><img src=\"" + _imports_60 + "\" class=\"all-social\"></div>", 2)
const _hoisted_468 = {
  key: 7,
  class: "act-modal-dim d-none",
  id: "detail-modal-6"
}
const _hoisted_469 = { class: "act-modal-container" }
const _hoisted_470 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_471 = [
  _hoisted_470
]
const _hoisted_472 = { class: "act-modal-header-m" }
const _hoisted_473 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_474 = [
  _hoisted_473
]
const _hoisted_475 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_476 = { class: "relative w-100" }
const _hoisted_477 = /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 6", -1)
const _hoisted_478 = /*#__PURE__*/_createElementVNode("p", null, "9 - 15 เม.ย 65", -1)
const _hoisted_479 = [
  _hoisted_477,
  _hoisted_478
]
const _hoisted_480 = { class: "scroll-modal" }
const _hoisted_481 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createTextVNode(" How to take good pictures & video with your phone "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("เรียนรู้กับแอมเวย์ครีเอเตอร์ ในหัวข้อ การแต่งภาพสไตล์ Health & Wellness "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ด้วยแอปพลิเคชัน ยอดฮิต ")
  ])
], -1)
const _hoisted_482 = { class: "act-modal-detail" }
const _hoisted_483 = { class: "act-modal-content act-modal-thumbnail" }
const _hoisted_484 = { class: "thumbnail-box" }
const _hoisted_485 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "คุณนิชกานต์ อ้วนเจริญ", -1)
const _hoisted_486 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "นักธุรกิจแอมเวย์ระดับแพลตินัม", -1)
const _hoisted_487 = { class: "thumbnail-box" }
const _hoisted_488 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, [
  /*#__PURE__*/_createTextVNode(" คุณชิดชนก อินทะกาล - "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("คุณณัฐพงศ์ เสรีนนท์ชัย ")
], -1)
const _hoisted_489 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "นักธุรกิจแอมเวย์ระดับแพลตินัมสองผู้สถาปนา", -1)
const _hoisted_490 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-content\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\"> วันที่ 9 เม.ย. 65 เวลา 13.00-15.00 น. <br><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </p></div><ul><li>แนะนำการใช้แอปพลิเคชัน และสอนเทคนิคการแต่งภาพ / วิดีโอสั้น เปลี่ยนความธรรมดา ให้ไม่ธรรมดา</li><li>แนวทางการคิดไอเดียเพื่อสร้างคอนเทนต์ผลิตภัณฑ์นิวทริไลท์</li></ul><a href=\"https://studioabothai.com/event/308\" class=\"link text-success\">https://studioabothai.com/event/308</a></div>", 1)
const _hoisted_491 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-greencontainer\"><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 1</h6></div><div class=\"detail\"><p>เรียนรู้การใช้แอปพลิเคชันง่ายๆ ในการถ่ายรูป และการถ่ายวิดีโอ โดย CU FIT GIRL</p><a href=\"https://studioabothai.com/pathway-summary/296\" class=\"link text-success\">https://studioabothai.com/pathway-summary/296</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 2</h6></div><div class=\"detail\"><p>รูปร่างดีด้วยสารอาหารบล็อกแอนด์เบิร์น</p><a href=\"https://studioabothai.com/pathway-summary/309\" class=\"link text-success\">https://studioabothai.com/pathway-summary/309</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div></div><div class=\"act-modal-greencontainer\"><div class=\"act-modal-product w-100\"><div class=\"product-image\"><h6>ทำคอนเทนต์ Health and Wellness</h6><img src=\"" + _imports_64 + "\" class=\"act-modal-product-img\"></div><div class=\"product-detail\"><div class=\"product-detail-text\"><p class=\"f-bold\">ผลิตภัณฑ์ Tie-in เลือกจาก</p><p>นิวทริไลท์ ดับเบิ้ลยู แพ็ค, นิวทริไลท์ คอนเซ็นเทรต แพ็ค, นิวทริไลท์ ไวทัล แพ็ค</p><p class=\"mt-16\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"actm-post-point-text\"><span class=\"text-success\">รับ 3 คะแนน</span> เมื่อโพสต์ครบ 3 โพสต์ </span></p></div></div></div><img src=\"" + _imports_60 + "\" class=\"all-social\"></div>", 2)
const _hoisted_493 = {
  key: 8,
  class: "act-modal-dim d-none",
  id: "detail-modal-7"
}
const _hoisted_494 = { class: "act-modal-container" }
const _hoisted_495 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_496 = [
  _hoisted_495
]
const _hoisted_497 = { class: "act-modal-header-m" }
const _hoisted_498 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_499 = [
  _hoisted_498
]
const _hoisted_500 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_501 = { class: "relative w-100" }
const _hoisted_502 = /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 7", -1)
const _hoisted_503 = /*#__PURE__*/_createElementVNode("p", null, "16 - 22 เม.ย 65", -1)
const _hoisted_504 = [
  _hoisted_502,
  _hoisted_503
]
const _hoisted_505 = { class: "scroll-modal" }
const _hoisted_506 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createTextVNode(" Get to know How to build your community "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("เรียนรู้การสร้างคอมมิวนิตีออนไลน์ Health & Wellness "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ในแบบฉบับของคุณ ")
  ])
], -1)
const _hoisted_507 = { class: "act-modal-detail" }
const _hoisted_508 = { class: "act-modal-content act-modal-thumbnail" }
const _hoisted_509 = { class: "thumbnail-box" }
const _hoisted_510 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "ครูทิป คุณมัณฑิตา จินดา", -1)
const _hoisted_511 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "ดิจิทัลโค้ช", -1)
const _hoisted_512 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-content\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\"> วันที่ 16 เม.ย. 65 เวลา 13.00-15.00 น. <br><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </p></div><ul><li>3 สิ่งสำคัญที่คุณต้องรู้ในการสร้างคอมมิวนิตี Health and Wellness ออนไลน์</li><li>มาเริ่มต้นสร้างคอมมิวนิตี Health and Wellness บน เฟซบุ๊ก และอินสตาแกรม</li><li>เทคนิคการเพิ่ม Engagement ในคอมมิวนิตีของคุณ</li><li>เคล็ดลับในการขยายคอมมิวนิตีให้เติบโต</li></ul><a href=\"https://studioabothai.com/event/309\" class=\"link text-success\">https://studioabothai.com/event/309</a></div>", 1)
const _hoisted_513 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-greencontainer\"><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 1</h6></div><div class=\"detail\"><p>เพิ่มแรงบันดาลใจของคุณ จากเจ้าของคอมมิวนิตี Health and Wellness</p><a href=\"https://studioabothai.com/pathway-summary/297\" class=\"link text-success\">https://studioabothai.com/pathway-summary/297</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 2</h6></div><div class=\"detail\"><p>CORE 8 Infinity … สุขภาพดี ไม่มีสิ้นสุด</p><a href=\"https://studioabothai.com/pathway-summary/310\" class=\"link text-success\">https://studioabothai.com/pathway-summary/310</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div></div><div class=\"act-modal-greencontainer\"><div class=\"act-modal-product w-100\"><div class=\"product-image\"><h6>ทำคอนเทนต์ Health and Wellness</h6><img src=\"" + _imports_65 + "\" class=\"act-modal-product-img\"></div><div class=\"product-detail\"><div class=\"product-detail-text\"><p class=\"f-bold\">ผลิตภัณฑ์ Tie-in เลือกจาก</p><p> นิวทริไลท์ คอลลาเจน, ทรูวิวิตี้ บาย นิวทริไลท์ ทรูมิสต์ ผลิตภัณฑ์เสริมอาหารชนิดเม็ด ทรูวิวิตี้ บาย นิวทริไลท์ ทรูมิสต์ พาวเดอร์ ผลิตภัณฑ์เสริมอาหารชนิดผง, นิวทริไลท์ โพรไบโอติก ดับเบิ้ล ยู </p><p class=\"mt-16\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"actm-post-point-text\"><span class=\"text-success\">รับ 3 คะแนน</span> เมื่อโพสต์ครบ 3 โพสต์ </span></p></div></div></div><img src=\"" + _imports_60 + "\" class=\"all-social\"></div>", 2)
const _hoisted_515 = {
  key: 9,
  class: "act-modal-dim d-none",
  id: "detail-modal-8"
}
const _hoisted_516 = { class: "act-modal-container" }
const _hoisted_517 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_518 = [
  _hoisted_517
]
const _hoisted_519 = { class: "act-modal-header-m" }
const _hoisted_520 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_521 = [
  _hoisted_520
]
const _hoisted_522 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_523 = { class: "relative w-100" }
const _hoisted_524 = /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 8", -1)
const _hoisted_525 = /*#__PURE__*/_createElementVNode("p", null, "23 - 29 เม.ย.65", -1)
const _hoisted_526 = [
  _hoisted_524,
  _hoisted_525
]
const _hoisted_527 = { class: "scroll-modal" }
const _hoisted_528 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createTextVNode(" Start your online community for Amway Business "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("เรียนรู้การสร้างคอมมิวนิตีออนไลน์ Health & Wellness สไตล์แอมเวย์ ")
  ])
], -1)
const _hoisted_529 = { class: "act-modal-detail" }
const _hoisted_530 = { class: "act-modal-content act-modal-thumbnail" }
const _hoisted_531 = { class: "thumbnail-box" }
const _hoisted_532 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, [
  /*#__PURE__*/_createTextVNode(" คุณจิรศักดิ์ อั้นใจเอก - "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("คุณชนากานต์ ปานแก้ว ")
], -1)
const _hoisted_533 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "นักธุรกิจแอมเวย์ระดับเพชร", -1)
const _hoisted_534 = { class: "thumbnail-box" }
const _hoisted_535 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, [
  /*#__PURE__*/_createTextVNode(" คุณพีระ พันธุ์พิพัฒน์ - "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("คุณชนัดดา ปรีชาหาญ ")
], -1)
const _hoisted_536 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "นักธุรกิจแอมเวย์ระดับเพชรบริหารสองผู้สถาปนา", -1)
const _hoisted_537 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-content\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\"> วันที่ 23 เม.ย. 65 เวลา 13.00-15.00 น. <br><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </p></div><ul><li>ทำไมนักธุรกิจแอมเวย์ควรมีคอมมิวนิตีออนไลน์ Health and Wellness</li><li>เริ่มต้นสร้างคอมมิวนิตีออนไลน์ Health and Wellness ในแบบฉบับนักธุรกิจแอมเวย์</li><li>ทำคอนเทนต์ในคอมมิวนิตี อย่างไรให้เกิด Engagement</li></ul><a href=\"https://studioabothai.com/event/310\" class=\"link text-success\">https://studioabothai.com/event/310</a></div>", 1)
const _hoisted_538 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-greencontainer\"><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 1</h6></div><div class=\"detail\"><p>เพิ่มแรงบันดาลใจของคุณ จากนักธุรกิจแอมเวย์ ที่เริ่มสร้างออนไลน์คอมมิวนิตี</p><a href=\"https://studioabothai.com/pathway-summary/298\" class=\"link text-success\">https://studioabothai.com/pathway-summary/298</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 2</h6></div><div class=\"detail\"><p>พลิกเบื้องหลังฉลากนิวทริไลท์&amp;ครบเครื่อง เรื่องดูแลกระดูก</p><a href=\"https://studioabothai.com/pathway-summary/311\" class=\"link text-success\">https://studioabothai.com/pathway-summary/311</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div></div><div class=\"act-modal-greencontainer\"><div class=\"act-modal-product w-100\"><div class=\"product-image\"><h6>ทำคอนเทนต์ Health and Wellness</h6><img src=\"" + _imports_65 + "\" class=\"act-modal-product-img\"></div><div class=\"product-detail\"><div class=\"product-detail-text\"><p class=\"f-bold\">ผลิตภัณฑ์ Tie-in เลือกจาก</p><p> นิวทริไลท์ คอลลาเจน, ทรูวิวิตี้ บาย นิวทริไลท์ ทรูมิสต์ <br>ผลิตภัณฑ์เสริมอาหารชนิดเม็ด ทรูวิวิตี้ บาย นิวทริไลท์ ทรูมิสต์ พาวเดอร์ <br>ผลิตภัณฑ์เสริมอาหารชนิดผง และนิวทริไลท์ โพรไบโอติค ดับเบิ้ล ยู </p><p class=\"mt-16\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"actm-post-point-text\"><span class=\"text-success\">รับ 3 คะแนน</span> เมื่อโพสต์ครบ 3 โพสต์ </span></p></div></div></div><img src=\"" + _imports_60 + "\" class=\"all-social\"></div>", 2)
const _hoisted_540 = {
  key: 10,
  class: "act-modal-dim d-none",
  id: "detail-modal-9"
}
const _hoisted_541 = { class: "act-modal-container" }
const _hoisted_542 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_543 = [
  _hoisted_542
]
const _hoisted_544 = { class: "act-modal-header-m" }
const _hoisted_545 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_546 = [
  _hoisted_545
]
const _hoisted_547 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_548 = { class: "relative w-100" }
const _hoisted_549 = /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 9", -1)
const _hoisted_550 = /*#__PURE__*/_createElementVNode("p", null, "30 เม.ย - 6 พ.ค 65", -1)
const _hoisted_551 = [
  _hoisted_549,
  _hoisted_550
]
const _hoisted_552 = { class: "scroll-modal" }
const _hoisted_553 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createTextVNode(" Get to know How to utilize your social media data "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ข้อมูลในโซเชียลมีเดีย สามารถนำมาปรับใช้กับการทำคอนเทนต์ "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ของเราได้อย่างไร ? ")
  ])
], -1)
const _hoisted_554 = { class: "act-modal-detail" }
const _hoisted_555 = { class: "act-modal-content act-modal-thumbnail" }
const _hoisted_556 = { class: "thumbnail-box" }
const _hoisted_557 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "คุณพุทธศักดิ์ ตันติสุทธิเวท", -1)
const _hoisted_558 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "Data Research Manager", -1)
const _hoisted_559 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-content\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\"> วันที่ 1 พ.ค. 65 เวลา 13.00-14.00 น. <br><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </p></div><ul><li>อัปเดตโซเชียลมีเดียเทรนด์ ออนไลน์ Health and Wellness</li><li>เทรนด์ ยอดฮิตมาแรง ของการทำคอนเทนต์ Health and Wellness</li><li>เข้าใจอัลกอริทึม เฟซบุ๊ก และอินสตาแกรม</li></ul><a href=\"https://studioabothai.com/event/311\" class=\"link text-success\">https://studioabothai.com/event/311</a></div>", 1)
const _hoisted_560 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-greencontainer\"><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 1</h6></div><div class=\"detail\"><p>เทคนิคการทำธุรกิจแอมเวย์ในแบบฉบับผู้นำแอมเวย์ 1</p><a href=\"https://studioabothai.com/pathway-summary/299\" class=\"link text-success\">https://studioabothai.com/pathway-summary/299</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 2</h6></div><div class=\"detail\"><p>ไฟโตนิวเทรียนท์...สารต้านอนุมูลอิสระทรงพลัง&amp;นึกได้ จำดี มีโฟกัส</p><a href=\"https://studioabothai.com/pathway-summary/312\" class=\"link text-success\">https://studioabothai.com/pathway-summary/312</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div></div><div class=\"act-modal-greencontainer\"><div class=\"act-modal-product w-100\"><div class=\"product-image\"><h6>ทำคอนเทนต์ Health and Wellness</h6><img src=\"" + _imports_66 + "\" class=\"act-modal-product-img\"></div><div class=\"product-detail\"><div class=\"product-detail-text\"><p class=\"f-bold\">ผลิตภัณฑ์ Tie-in เลือกจาก</p><p>ผลิตภัณฑ์ในกลุ่มนิวทริไลท์ CORE 8</p><p class=\"mt-16\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"actm-post-point-text\"><span class=\"text-success\">รับ 3 คะแนน</span> เมื่อโพสต์ครบ 3 โพสต์ </span></p></div></div></div><img src=\"" + _imports_60 + "\" class=\"all-social\"></div>", 2)
const _hoisted_562 = {
  key: 11,
  class: "act-modal-dim d-none",
  id: "detail-modal-10"
}
const _hoisted_563 = { class: "act-modal-container" }
const _hoisted_564 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_565 = [
  _hoisted_564
]
const _hoisted_566 = { class: "act-modal-header-m" }
const _hoisted_567 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_568 = [
  _hoisted_567
]
const _hoisted_569 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_570 = { class: "relative w-100" }
const _hoisted_571 = /*#__PURE__*/_createElementVNode("h5", null, "สัปดาห์ที่ 10", -1)
const _hoisted_572 = /*#__PURE__*/_createElementVNode("p", null, "7 - 13 พ.ค 65", -1)
const _hoisted_573 = [
  _hoisted_571,
  _hoisted_572
]
const _hoisted_574 = { class: "scroll-modal" }
const _hoisted_575 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createTextVNode(" Successful story "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("เรื่องราวความสำเร็จของการทำคอมมิวนิตี Health & Wellness "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ในแบบฉบับแอมเวย์ ")
  ])
], -1)
const _hoisted_576 = { class: "act-modal-detail" }
const _hoisted_577 = { class: "act-modal-content act-modal-thumbnail" }
const _hoisted_578 = { class: "thumbnail-box" }
const _hoisted_579 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, [
  /*#__PURE__*/_createTextVNode(" คุณภควดี - คุณศรัณย์ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("วรสุทธิกานนท์ ")
], -1)
const _hoisted_580 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "นักธุรกิจแอมเวย์ระดับเพชรบริหารสองผู้สถาปนา", -1)
const _hoisted_581 = { class: "thumbnail-box" }
const _hoisted_582 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, [
  /*#__PURE__*/_createTextVNode(" คุณรัฐธีร์ ชาญชินปวิณณัช - "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("คุณนิยุตรัตน์ จามพันธ์ ")
], -1)
const _hoisted_583 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "นักธุรกิจแอมเวย์ระดับมงกุฎทูต", -1)
const _hoisted_584 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-content\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\"> วันที่ 7 พ.ค. 65 เวลา 13.00-15.00 น. <br><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </p></div><ul><li>ความสำคัญของการขยายโอกาสทางธุรกิจด้วยการสร้างคอมมิวนิตี Health and Wellness</li><li>แนวทางการเชื่อมต่อธุรกิจออฟไลน์เดิมที่นักธุรกิจแอมเวย์ทำอยู่รวมกับแนวทางใหม่บนออนไลน์โซเชียลมีเดียแพลตฟอร์ม</li></ul><a href=\"https://studioabothai.com/event/312\" class=\"link text-success\">https://studioabothai.com/event/312</a></div>", 1)
const _hoisted_585 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modal-greencontainer\"><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 1</h6></div><div class=\"detail\"><p>เทคนิคการทำธุรกิจแอมเวย์ในแบบฉบับผู้นำแอมเวย์ 2</p><a href=\"https://studioabothai.com/pathway-summary/300\" class=\"link text-success\">https://studioabothai.com/pathway-summary/300</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div><div class=\"act-modal-chapter w-100\"><div class=\"chapter\"><h6>บทเรียนที่ 2</h6></div><div class=\"detail\"><p>Be healthy เรื่อง(ไม่)ลับในการดูแลสุขภาพดี แบบฉบับผู้หญิง</p><a href=\"https://studioabothai.com/pathway-summary/313\" class=\"link text-success\">https://studioabothai.com/pathway-summary/313</a></div><div class=\"point\"><span class=\"point-display\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"point-display-text\"><span class=\"text-success\">รับ 2 คะแนน</span> ต่อบทเรียน </span></span></div></div></div><div class=\"act-modal-greencontainer\"><div class=\"act-modal-product w-100\"><div class=\"product-image\"><h6>ทำคอนเทนต์ Health and Wellness</h6><img src=\"" + _imports_66 + "\" class=\"act-modal-product-img\"></div><div class=\"product-detail\"><div class=\"product-detail-text\"><p class=\"f-bold\">ผลิตภัณฑ์ Tie-in เลือกจาก</p><p>ผลิตภัณฑ์ในกลุ่มนิวทริไลท์ CORE 8</p><p class=\"mt-16\"><img src=\"" + _imports_58 + "\" class=\"point-icon\"><span class=\"actm-post-point-text\"><span class=\"text-success\">รับ 3 คะแนน</span> เมื่อโพสต์ครบ 3 โพสต์ </span></p></div></div></div><img src=\"" + _imports_60 + "\" class=\"all-social\"></div>", 2)
const _hoisted_587 = {
  key: 12,
  class: "act-modal-dim d-none",
  id: "detail-modal-11"
}
const _hoisted_588 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_67,
  class: "cloud-end-left-m"
}, null, -1)
const _hoisted_589 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_68,
  class: "cloud-end-right-m"
}, null, -1)
const _hoisted_590 = { class: "act-modalend-container act-modal-container" }
const _hoisted_591 = /*#__PURE__*/_createElementVNode("img", { src: _imports_56 }, null, -1)
const _hoisted_592 = [
  _hoisted_591
]
const _hoisted_593 = { class: "act-modal-header-m" }
const _hoisted_594 = /*#__PURE__*/_createElementVNode("img", { src: _imports_57 }, null, -1)
const _hoisted_595 = [
  _hoisted_594
]
const _hoisted_596 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "รายละเอียดกิจกรรม")
], -1)
const _hoisted_597 = { class: "relative w-100" }
const _hoisted_598 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_67,
  class: "cloud-end-left"
}, null, -1)
const _hoisted_599 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_68,
  class: "cloud-end-right"
}, null, -1)
const _hoisted_600 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_69,
  class: "fireworks-left"
}, null, -1)
const _hoisted_601 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_69,
  class: "fireworks-right"
}, null, -1)
const _hoisted_602 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createTextVNode("Creators Challenge"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Celebration Day 2022")
], -1)
const _hoisted_603 = [
  _hoisted_602
]
const _hoisted_604 = { class: "scroll-modal-end" }
const _hoisted_605 = /*#__PURE__*/_createElementVNode("div", { class: "text-center act-modalend-header" }, [
  /*#__PURE__*/_createElementVNode("h5"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_70,
    class: "plain-end"
  }),
  /*#__PURE__*/_createElementVNode("h6", null, " ที่จะได้ไปทริปท่องเที่ยวญี่ปุ่น เกียวโต โอซาก้า ")
], -1)
const _hoisted_606 = { class: "act-modalend-detail" }
const _hoisted_607 = { class: "act-modalend-detail-left" }
const _hoisted_608 = { class: "act-modal-content act-modal-thumbnail act-modalend-content" }
const _hoisted_609 = { class: "thumbnail-box" }
const _hoisted_610 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "คุณทศพร นิษฐานนท์", -1)
const _hoisted_611 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "ผู้จัดการทั่วไปบริษัทแอมเวย์ ประเทศไทย", -1)
const _hoisted_612 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modalend-detail-right\"><div class=\"act-modal-detail-header\"><img src=\"" + _imports_34 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\"> รับชมการถ่ายทอดสด ทางเว็บไซต์ <span class=\"text-danger\">studioABOThai.com</span></p><p class=\"f-bold point\">วันที่ 28 พ.ค. 65 เวลา 13.00-14.30 น.</p><a href=\"https://studioabothai.com/event/313\" class=\"text-success f-bold\">https://studioabothai.com/event/313</a></div><div class=\"act-modal-detail-header mt-16\"><img src=\"" + _imports_71 + "\" class=\"modal-icon_live\"><p class=\"f-extra-bold\">รับชมผ่าน Facebook Creators Thailand Community</p><a href=\"https://www.facebook.com/groups/creatorsthailandcommunity\" class=\"text-success f-bold\">https://www.facebook.com/groups/creatorsthailandcommunity</a></div></div>", 1)
const _hoisted_613 = /*#__PURE__*/_createStaticVNode("<div class=\"act-modalend-detail\"><div class=\"act-modalend-detail-left\"><img src=\"" + _imports_72 + "\" class=\"people-end\"></div><div class=\"act-modalend-detail-right reward\"><img src=\"" + _imports_53 + "\" class=\"reward\"><p>สัมภาษณ์ความประทับใจ</p><h6>10 ทีม ที่ได้รับรางวัลชนะเลิศ</h6></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/activity",
          class: "header-logo"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "final_score"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "leader_board"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: "final_result"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.currentWeek > 0 && !_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  to: "/team_score_board"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _hoisted_14
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.currentWeek > 0 && !_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: "/leader_board"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _hoisted_16
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: "/challenge",
              class: "btn-red",
              style: {"width":"184px"}
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "profile-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showProfileInfo();})
            }, [
              _createElementVNode("img", {
                src: _ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')
              }, null, 8, _hoisted_19)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                  _createElementVNode("div", _hoisted_24, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
                ])
              ]),
              _createVNode(_component_router_link, {
                to: "/profile",
                class: "link-black"
              }, {
                default: _withCtx(() => [
                  _hoisted_25,
                  _hoisted_26
                ]),
                _: 1
              }),
              _hoisted_27
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", {
            class: "ham",
            id: "mobile-menu",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openMenu(this)))
          }),
          _createVNode(_component_router_link, {
            to: "/challenge",
            class: "header-logo"
          }, {
            default: _withCtx(() => [
              _hoisted_30
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", {
            class: "profile-icon",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showProfileInfo();})
          }, [
            _createElementVNode("img", {
              src: _ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')
            }, null, 8, _hoisted_32)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                _createElementVNode("div", _hoisted_37, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
              ])
            ]),
            _createVNode(_component_router_link, {
              to: "/profile",
              class: "link-black"
            }, {
              default: _withCtx(() => [
                _hoisted_38,
                _hoisted_39
              ]),
              _: 1
            }),
            _hoisted_40
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          (_ctx.isFinal)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "final_score"
              }, {
                default: _withCtx(() => [
                  _hoisted_42,
                  _hoisted_43
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isFinal)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "leader_board"
              }, {
                default: _withCtx(() => [
                  _hoisted_44,
                  _hoisted_45
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isFinal)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: "final_result"
              }, {
                default: _withCtx(() => [
                  _hoisted_46,
                  _hoisted_47
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.currentWeek > 0 && !_ctx.isFinal)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 3,
                to: "team_score_board"
              }, {
                default: _withCtx(() => [
                  _hoisted_48,
                  _hoisted_49
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.currentWeek > 0 && !_ctx.isFinal)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                to: "leader_board"
              }, {
                default: _withCtx(() => [
                  _hoisted_50,
                  _hoisted_51
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: "/challenge",
            class: "btn-red fixed",
            style: {"right":"16px","bottom":"0","width":"calc(100% - 32px)"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMenu()))
          }, {
            default: _withCtx(() => [
              _hoisted_52
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.currentWeek > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _hoisted_57,
              _hoisted_58,
              _createElementVNode("h3", null, _toDisplayString(_ctx.team.team_name), 1),
              _createElementVNode("div", {
                class: "act-banner-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})` })
              }, [
                _createElementVNode("h4", _hoisted_59, "อันดับที่ " + _toDisplayString(_ctx.team.rank), 1),
                _createElementVNode("p", _hoisted_60, " สัปดาห์ที่ " + _toDisplayString(_ctx.currentWeek), 1)
              ], 4),
              (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 1 && _ctx.team.rank <= 20)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, _hoisted_64))
                : _createCommentVNode("", true),
              (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 21 && _ctx.team.rank <= 40)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, _hoisted_68))
                : _createCommentVNode("", true),
              (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 41 && _ctx.team.rank <= 70)
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_72))
                : _createCommentVNode("", true),
              (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 1 && _ctx.team.rank <= 20)
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_76))
                : _createCommentVNode("", true),
              (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 21 && _ctx.team.rank <= 40)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_80))
                : _createCommentVNode("", true),
              (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 41 && _ctx.team.rank <= 70)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, _hoisted_84))
                : _createCommentVNode("", true),
              (_ctx.team.rank > 70)
                ? (_openBlock(), _createElementBlock("div", _hoisted_85, _hoisted_88))
                : _createCommentVNode("", true),
              (_ctx.team.rank <= 70)
                ? (_openBlock(), _createElementBlock("a", _hoisted_89, _hoisted_91))
                : _createCommentVNode("", true),
              _hoisted_92
            ])
          ]),
          _hoisted_93,
          _hoisted_94
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentWeek < 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, _hoisted_102))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_103, [
      _hoisted_104,
      _hoisted_105,
      _hoisted_106,
      _hoisted_107,
      _createElementVNode("div", _hoisted_108, [
        _hoisted_109,
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("div", {
            class: _normalizeClass(`station-left ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-05')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("div", {
                class: _normalizeClass(`station act-station-left ${_ctx.currentDate.isBetween('2022-03-05', '2022-03-11', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_112,
                _createElementVNode("div", {
                  class: "act-ribbon",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_114, 4),
                _createElementVNode("div", {
                  class: "thumbnail-box",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentDate.isBetween('2022-03-05', '2022-03-11', 'day', '[]') ? _ctx.toggleModal(1) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station1.jpg')})` })
                      }, null, 4)
                    ]),
                    _hoisted_117
                  ])
                ]),
                _hoisted_118
              ], 2)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-center ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-12')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("div", {
                class: _normalizeClass(`station station-one act-station-right ${_ctx.currentDate.isBetween('2022-03-12', '2022-03-18', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_120,
                _createElementVNode("div", {
                  class: "act-ribbon",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_122, 4),
                _createElementVNode("div", {
                  class: "thumbnail-box",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentDate.isBetween('2022-03-12', '2022-03-18', 'day', '[]') ? _ctx.toggleModal(2) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("div", _hoisted_124, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station1.jpg')})` })
                      }, null, 4)
                    ]),
                    _hoisted_125
                  ])
                ]),
                _hoisted_126
              ], 2)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-right ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-19')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", {
                class: _normalizeClass(`station station-two act-station-center ${_ctx.currentDate.isBetween('2022-03-19', '2022-03-25', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_128,
                _createElementVNode("div", {
                  class: "act-ribbon two-people",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_130, 4),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-left",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.currentDate.isBetween('2022-03-19', '2022-03-25', 'day', '[]') ? _ctx.toggleModal(3) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("div", _hoisted_132, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station3-2.png')})` })
                      }, null, 4)
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-right",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.currentDate.isBetween('2022-03-19', '2022-03-25', 'day', '[]') ? _ctx.toggleModal(3) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_133, [
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station3-1.png')})` })
                      }, null, 4)
                    ]),
                    _hoisted_135
                  ])
                ]),
                _hoisted_136
              ], 2),
              _hoisted_137,
              _hoisted_138,
              _hoisted_139
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-left ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-26')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_140, [
              _createElementVNode("div", {
                class: _normalizeClass(`station station-two act-station-left ${_ctx.currentDate.isBetween('2022-03-26', '2022-04-01', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_141,
                _createElementVNode("div", {
                  class: "act-ribbon two-people",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_143, 4),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-left",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.currentDate.isBetween('2022-03-26', '2022-04-01', 'day', '[]') ? _ctx.toggleModal(4) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_144, [
                    _createElementVNode("div", _hoisted_145, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station4-1.png')})` })
                      }, null, 4)
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-right",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.currentDate.isBetween('2022-03-26', '2022-04-01', 'day', '[]') ? _ctx.toggleModal(4) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_146, [
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station4-2.png')})` })
                      }, null, 4)
                    ]),
                    _hoisted_148
                  ])
                ]),
                _hoisted_149
              ], 2),
              _hoisted_150,
              _hoisted_151,
              _hoisted_152
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-center ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-02')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_153, [
              _createElementVNode("div", {
                class: _normalizeClass(`station station-two act-station-right ${_ctx.currentDate.isBetween('2022-04-02', '2022-04-08', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_154,
                _createElementVNode("div", {
                  class: "act-ribbon two-people",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_156, 4),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-left",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-02', '2022-04-08', 'day', '[]') ? _ctx.toggleModal(5) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_157, [
                    _createElementVNode("div", _hoisted_158, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station5-1.png')})` })
                      }, null, 4)
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-right",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-02', '2022-04-08', 'day', '[]') ? _ctx.toggleModal(5) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_159, [
                    _createElementVNode("div", _hoisted_160, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station5-2.png')})` })
                      }, null, 4)
                    ]),
                    _hoisted_161
                  ])
                ]),
                _hoisted_162
              ], 2),
              _hoisted_163,
              _hoisted_164
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-right ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-09')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_165, [
              _createElementVNode("div", {
                class: _normalizeClass(`station station-two act-station-center  ${_ctx.currentDate.isBetween('2022-04-09', '2022-04-15', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_166,
                _createElementVNode("div", {
                  class: "act-ribbon two-people",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_168, 4),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-left",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-09', '2022-04-15', 'day', '[]') ? _ctx.toggleModal(6) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_169, [
                    _createElementVNode("div", _hoisted_170, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station6-2.png')})` })
                      }, null, 4)
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-right",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-09', '2022-04-15', 'day', '[]') ? _ctx.toggleModal(6) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_171, [
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station6-1.png')})` })
                      }, null, 4)
                    ]),
                    _hoisted_173
                  ])
                ]),
                _hoisted_174
              ], 2),
              _hoisted_175,
              _hoisted_176
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-left ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-16')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_177, [
              _createElementVNode("div", {
                class: _normalizeClass(`station act-station-left  ${_ctx.currentDate.isBetween('2022-04-16', '2022-04-22', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_178,
                _createElementVNode("div", {
                  class: "act-ribbon",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_180, 4),
                _createElementVNode("div", {
                  class: "thumbnail-box",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-16', '2022-04-22', 'day', '[]') ? _ctx.toggleModal(7) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_181, [
                    _createElementVNode("div", _hoisted_182, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station7.png')})` })
                      }, null, 4)
                    ]),
                    _hoisted_183
                  ])
                ]),
                _hoisted_184
              ], 2),
              _hoisted_185,
              _hoisted_186
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-center ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-23')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_187, [
              _createElementVNode("div", {
                class: _normalizeClass(`station station-two act-station-right  ${_ctx.currentDate.isBetween('2022-04-23', '2022-04-29', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_188,
                _createElementVNode("div", {
                  class: "act-ribbon two-people",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_190, 4),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-left",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-23', '2022-04-29', 'day', '[]') ? _ctx.toggleModal(8) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_191, [
                    _createElementVNode("div", _hoisted_192, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station8-1.png')})` })
                      }, null, 4)
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-right",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-23', '2022-04-29', 'day', '[]') ? _ctx.toggleModal(8) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_193, [
                    _createElementVNode("div", _hoisted_194, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station8-2.png')})` })
                      }, null, 4)
                    ]),
                    _hoisted_195
                  ])
                ]),
                _hoisted_196
              ], 2),
              _hoisted_197,
              _hoisted_198
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-right ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-30')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_199, [
              _createElementVNode("div", {
                class: _normalizeClass(`station act-station-center ${_ctx.currentDate.isBetween('2022-04-30', '2022-05-06', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_200,
                _createElementVNode("div", {
                  class: "act-ribbon",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_202, 4),
                _createElementVNode("div", _hoisted_203, [
                  _createElementVNode("div", {
                    class: "thumbnail-checkpoint",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-30', '2022-05-06', 'day', '[]') ? _ctx.toggleModal(9) : 'javascript:void(0)'))
                  }, [
                    _createElementVNode("div", _hoisted_204, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station9.png')})` })
                      }, null, 4)
                    ]),
                    _hoisted_205
                  ])
                ]),
                _hoisted_206
              ], 2),
              _hoisted_207,
              _hoisted_208
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-left ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-07')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_209, [
              _createElementVNode("div", {
                class: _normalizeClass(`station station-two act-station-left ${_ctx.currentDate.isBetween('2022-05-07', '2022-05-13', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_210,
                _createElementVNode("div", {
                  class: "act-ribbon two-people",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_212, 4),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-left",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.currentDate.isBetween('2022-05-07', '2022-05-13', 'day', '[]') ? _ctx.toggleModal(10) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_213, [
                    _createElementVNode("div", _hoisted_214, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station10-1.png')})` })
                      }, null, 4)
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "thumbnail-box thumbnail-box-right",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.currentDate.isBetween('2022-05-07', '2022-05-13', 'day', '[]') ? _ctx.toggleModal(10) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_215, [
                    _createElementVNode("div", _hoisted_216, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station10-2.png')})` })
                      }, null, 4)
                    ]),
                    _hoisted_217
                  ])
                ]),
                _hoisted_218
              ], 2),
              _hoisted_219,
              _hoisted_220
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-center ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-14')) ? 'active' : ''}`)
          }, _hoisted_222, 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-right ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-21')) ? 'active' : ''}`)
          }, _hoisted_224, 2),
          _createElementVNode("div", {
            class: _normalizeClass(`station-right ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-28')) ? 'active' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_225, [
              _createElementVNode("div", {
                class: _normalizeClass(`station act-station-end ${_ctx.currentDate.isBetween('2022-05-28', '2022-12-31', 'day', '[]') ? 'checkpoint' : ''}`)
              }, [
                _hoisted_226,
                _createElementVNode("div", {
                  class: "act-ribbon",
                  style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon.svg')})` })
                }, _hoisted_228, 4),
                _createElementVNode("div", {
                  class: "thumbnail-box",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.currentDate.isBetween('2022-05-28', '2022-12-31', 'day', '[]') ? _ctx.toggleModal(11) : 'javascript:void(0)'))
                }, [
                  _createElementVNode("div", _hoisted_229, [
                    _createElementVNode("div", _hoisted_230, [
                      _createElementVNode("div", {
                        class: "thumbnail-img",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station11.png')})` })
                      }, null, 4)
                    ]),
                    _hoisted_231
                  ])
                ]),
                _hoisted_232
              ], 2),
              _hoisted_233,
              _hoisted_234
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_235, [
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station first-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-12')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-03-05', '2022-03-11', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_236,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_238, 4),
            _createElementVNode("div", _hoisted_239, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.currentDate.isBetween('2022-03-05', '2022-03-11', 'day', '[]') ? _ctx.toggleModal(1) : 'javascript:void(0)'))
              }, [
                _createElementVNode("div", _hoisted_240, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station1.jpg')})` })
                  }, null, 4)
                ])
              ])
            ]),
            _hoisted_241
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station  ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-19')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-03-12', '2022-03-18', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_242,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_244, 4),
            _createElementVNode("div", _hoisted_245, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.currentDate.isBetween('2022-03-12', '2022-03-18', 'day', '[]') ? _ctx.toggleModal(2) : 'javascript:void(0)'))
              }, [
                _createElementVNode("div", _hoisted_246, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station1.jpg')})` })
                  }, null, 4),
                  _hoisted_247
                ])
              ])
            ]),
            _hoisted_248
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-26')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-03-19', '2022-03-25', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_251,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_253, 4),
            _createElementVNode("div", _hoisted_254, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box two-thumbnail",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.currentDate.isBetween('2022-03-19', '2022-03-25', 'day', '[]') ? _ctx.toggleModal(3) : 'javascript:void(0)'))
              }, [
                _createElementVNode("div", _hoisted_255, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station3-2.png')})` })
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_256, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station3-1.png')})` })
                  }, null, 4),
                  _hoisted_257
                ])
              ])
            ]),
            _hoisted_258
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-02')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-03-26', '2022-04-01', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_261,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_263, 4),
            _createElementVNode("div", _hoisted_264, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box two-thumbnail",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.currentDate.isBetween('2022-03-26', '2022-04-01', 'day', '[]') ? _ctx.toggleModal(4) : 'javascript:void(0)'))
              }, [
                _createElementVNode("div", _hoisted_265, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station4-1.png')})` })
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_266, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station4-2.png')})` })
                  }, null, 4),
                  _hoisted_267
                ])
              ])
            ]),
            _hoisted_268
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-09')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-04-02', '2022-04-08', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_271,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_273, 4),
            _createElementVNode("div", _hoisted_274, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box two-thumbnail",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-02', '2022-04-08', 'day', '[]') ? _ctx.toggleModal(5) : 'javascript:void(0)'))
              }, [
                _createElementVNode("div", _hoisted_275, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station5-1.png')})` })
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_276, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station5-2.png')})` })
                  }, null, 4),
                  _hoisted_277
                ])
              ])
            ]),
            _hoisted_278
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-16')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-04-09', '2022-04-15', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_280,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_282, 4),
            _createElementVNode("div", _hoisted_283, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box two-thumbnail",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-09', '2022-04-15', 'day', '[]') ? _ctx.toggleModal(6) : 'javascript:void(0)'))
              }, [
                _createElementVNode("div", _hoisted_284, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station6-2.png')})` })
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_285, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station6-1.png')})` })
                  }, null, 4),
                  _hoisted_286
                ])
              ])
            ]),
            _hoisted_287
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-23')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-04-16', '2022-04-22', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_289,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_291, 4),
            _createElementVNode("div", _hoisted_292, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-16', '2022-04-22', 'day', '[]') ? _ctx.toggleModal(7) : 'javascript:void(0)'))
              }, [
                _createElementVNode("div", _hoisted_293, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station7.png')})` })
                  }, null, 4),
                  _hoisted_294
                ])
              ])
            ]),
            _hoisted_295
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-30')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-04-23', '2022-04-29', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_298,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_300, 4),
            _createElementVNode("div", _hoisted_301, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box two-thumbnail",
                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-23', '2022-04-29', 'day', '[]') ? _ctx.toggleModal(8) : 'javascript:void(0)'))
              }, [
                _createElementVNode("div", _hoisted_302, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station8-1.png')})` })
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_303, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station8-2.png')})` })
                  }, null, 4),
                  _hoisted_304
                ])
              ])
            ]),
            _hoisted_305
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-07')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-04-30', '2022-05-06', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_307,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_309, 4),
            _createElementVNode("div", _hoisted_310, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box",
                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.currentDate.isBetween('2022-04-30', '2022-05-06', 'day', '[]') ? _ctx.toggleModal(9) : 'javascript:void(0)'))
              }, [
                _createElementVNode("div", _hoisted_311, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station9.png')})` })
                  }, null, 4),
                  _hoisted_312
                ])
              ])
            ]),
            _hoisted_313
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-14')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-05-07', '2022-05-13', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_316,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_318, 4),
            _createElementVNode("div", _hoisted_319, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box two-thumbnail",
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.currentDate.isBetween('2022-05-07', '2022-05-13', 'day', '[]') ? _ctx.toggleModal(10) : 'javascript:void(0)'))
              }, [
                _createElementVNode("div", _hoisted_320, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station10-1.png')})` })
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_321, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station10-2.png')})` })
                  }, null, 4),
                  _hoisted_322
                ])
              ])
            ]),
            _hoisted_323
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-17')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-05-14', '2022-05-16', 'day', '[]') ? 'checkpoint' : ''}`)
          }, _hoisted_326, 2),
          _createElementVNode("div", {
            class: _normalizeClass(`actm-station actm-end-station ${_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-28')) ? 'active' : ''} ${_ctx.currentDate.isBetween('2022-05-28', '2023-05-23', 'day', '[]') ? 'checkpoint' : ''}`)
          }, [
            _hoisted_327,
            _createElementVNode("div", {
              class: "actm-ribbon",
              style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-m.svg')})` })
            }, _hoisted_329, 4),
            _hoisted_330,
            _createElementVNode("div", _hoisted_331, [
              _createElementVNode("div", {
                class: "actm-thumbnail-box",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-28')) ? _ctx.toggleModal(11) : 'javascript:void(11)'))
              }, [
                _createElementVNode("div", _hoisted_332, [
                  _createElementVNode("div", {
                    class: "actm-thumbnail-img",
                    style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station11.png')})` })
                  }, null, 4),
                  _hoisted_333
                ])
              ])
            ]),
            _hoisted_334
          ], 2),
          _hoisted_336
        ])
      ]),
      _hoisted_337
    ]),
    _createElementVNode("div", _hoisted_343, [
      _hoisted_344,
      _createElementVNode("div", {
        class: "act-table-mountain",
        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/mountain-bottom.svg')})` })
      }, _hoisted_347, 4),
      _hoisted_348
    ]),
    _hoisted_349,
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-05')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_350, [
          _createElementVNode("div", _hoisted_351, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.toggleModal(1)))
            }, _hoisted_353),
            _createElementVNode("div", _hoisted_354, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.toggleModal(1)))
              }, _hoisted_356),
              _hoisted_357
            ]),
            _createElementVNode("div", _hoisted_358, [
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_361, 4),
              _createElementVNode("div", _hoisted_362, [
                _hoisted_363,
                _createElementVNode("div", _hoisted_364, [
                  _createElementVNode("div", _hoisted_365, [
                    _createElementVNode("div", _hoisted_366, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station1.jpg')})`})
                      }, null, 4),
                      _hoisted_367,
                      _hoisted_368
                    ])
                  ]),
                  _hoisted_369
                ]),
                _hoisted_370
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-12')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_372, [
          _createElementVNode("div", _hoisted_373, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.toggleModal(2)))
            }, _hoisted_375),
            _createElementVNode("div", _hoisted_376, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.toggleModal(2)))
              }, _hoisted_378),
              _hoisted_379
            ]),
            _createElementVNode("div", _hoisted_380, [
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_383, 4),
              _createElementVNode("div", _hoisted_384, [
                _hoisted_385,
                _createElementVNode("div", _hoisted_386, [
                  _createElementVNode("div", _hoisted_387, [
                    _createElementVNode("div", _hoisted_388, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station1.jpg')})`})
                      }, null, 4),
                      _hoisted_389,
                      _hoisted_390
                    ])
                  ]),
                  _hoisted_391
                ]),
                _hoisted_392
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-19')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_393, [
          _createElementVNode("div", _hoisted_394, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.toggleModal(3)))
            }, _hoisted_396),
            _createElementVNode("div", _hoisted_397, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.toggleModal(3)))
              }, _hoisted_399),
              _hoisted_400
            ]),
            _createElementVNode("div", _hoisted_401, [
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_404, 4),
              _createElementVNode("div", _hoisted_405, [
                _hoisted_406,
                _createElementVNode("div", _hoisted_407, [
                  _createElementVNode("div", _hoisted_408, [
                    _createElementVNode("div", _hoisted_409, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station3-2.png')})`})
                      }, null, 4),
                      _hoisted_410,
                      _hoisted_411
                    ]),
                    _createElementVNode("div", _hoisted_412, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station3-1.png')})`})
                      }, null, 4),
                      _hoisted_413,
                      _hoisted_414
                    ])
                  ]),
                  _hoisted_415
                ]),
                _hoisted_416
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-03-26')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_418, [
          _createElementVNode("div", _hoisted_419, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.toggleModal(4)))
            }, _hoisted_421),
            _createElementVNode("div", _hoisted_422, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.toggleModal(4)))
              }, _hoisted_424),
              _hoisted_425
            ]),
            _createElementVNode("div", _hoisted_426, [
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_429, 4),
              _createElementVNode("div", _hoisted_430, [
                _hoisted_431,
                _createElementVNode("div", _hoisted_432, [
                  _createElementVNode("div", _hoisted_433, [
                    _createElementVNode("div", _hoisted_434, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station4-1.png')})`})
                      }, null, 4),
                      _hoisted_435,
                      _hoisted_436
                    ]),
                    _createElementVNode("div", _hoisted_437, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station4-2.png')})`})
                      }, null, 4),
                      _hoisted_438,
                      _hoisted_439
                    ])
                  ]),
                  _hoisted_440
                ]),
                _hoisted_441
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-02')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_443, [
          _createElementVNode("div", _hoisted_444, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.toggleModal(5)))
            }, _hoisted_446),
            _createElementVNode("div", _hoisted_447, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.toggleModal(5)))
              }, _hoisted_449),
              _hoisted_450
            ]),
            _createElementVNode("div", _hoisted_451, [
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_454, 4),
              _createElementVNode("div", _hoisted_455, [
                _hoisted_456,
                _createElementVNode("div", _hoisted_457, [
                  _createElementVNode("div", _hoisted_458, [
                    _createElementVNode("div", _hoisted_459, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station5-2.png')})`})
                      }, null, 4),
                      _hoisted_460,
                      _hoisted_461
                    ]),
                    _createElementVNode("div", _hoisted_462, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station5-1.png')})`})
                      }, null, 4),
                      _hoisted_463,
                      _hoisted_464
                    ])
                  ]),
                  _hoisted_465
                ]),
                _hoisted_466
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-09')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_468, [
          _createElementVNode("div", _hoisted_469, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.toggleModal(6)))
            }, _hoisted_471),
            _createElementVNode("div", _hoisted_472, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.toggleModal(6)))
              }, _hoisted_474),
              _hoisted_475
            ]),
            _createElementVNode("div", _hoisted_476, [
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_479, 4),
              _createElementVNode("div", _hoisted_480, [
                _hoisted_481,
                _createElementVNode("div", _hoisted_482, [
                  _createElementVNode("div", _hoisted_483, [
                    _createElementVNode("div", _hoisted_484, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station6-2.png')})`})
                      }, null, 4),
                      _hoisted_485,
                      _hoisted_486
                    ]),
                    _createElementVNode("div", _hoisted_487, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station6-1.png')})`})
                      }, null, 4),
                      _hoisted_488,
                      _hoisted_489
                    ])
                  ]),
                  _hoisted_490
                ]),
                _hoisted_491
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-16')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_493, [
          _createElementVNode("div", _hoisted_494, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.toggleModal(7)))
            }, _hoisted_496),
            _createElementVNode("div", _hoisted_497, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.toggleModal(7)))
              }, _hoisted_499),
              _hoisted_500
            ]),
            _createElementVNode("div", _hoisted_501, [
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_504, 4),
              _createElementVNode("div", _hoisted_505, [
                _hoisted_506,
                _createElementVNode("div", _hoisted_507, [
                  _createElementVNode("div", _hoisted_508, [
                    _createElementVNode("div", _hoisted_509, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station7.png')})`})
                      }, null, 4),
                      _hoisted_510,
                      _hoisted_511
                    ])
                  ]),
                  _hoisted_512
                ]),
                _hoisted_513
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-23')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_515, [
          _createElementVNode("div", _hoisted_516, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.toggleModal(8)))
            }, _hoisted_518),
            _createElementVNode("div", _hoisted_519, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.toggleModal(8)))
              }, _hoisted_521),
              _hoisted_522
            ]),
            _createElementVNode("div", _hoisted_523, [
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_526, 4),
              _createElementVNode("div", _hoisted_527, [
                _hoisted_528,
                _createElementVNode("div", _hoisted_529, [
                  _createElementVNode("div", _hoisted_530, [
                    _createElementVNode("div", _hoisted_531, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station8-2.png')})`})
                      }, null, 4),
                      _hoisted_532,
                      _hoisted_533
                    ]),
                    _createElementVNode("div", _hoisted_534, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station8-1.png')})`})
                      }, null, 4),
                      _hoisted_535,
                      _hoisted_536
                    ])
                  ]),
                  _hoisted_537
                ]),
                _hoisted_538
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-04-30')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_540, [
          _createElementVNode("div", _hoisted_541, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.toggleModal(9)))
            }, _hoisted_543),
            _createElementVNode("div", _hoisted_544, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.toggleModal(9)))
              }, _hoisted_546),
              _hoisted_547
            ]),
            _createElementVNode("div", _hoisted_548, [
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_551, 4),
              _createElementVNode("div", _hoisted_552, [
                _hoisted_553,
                _createElementVNode("div", _hoisted_554, [
                  _createElementVNode("div", _hoisted_555, [
                    _createElementVNode("div", _hoisted_556, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station9.png')})`})
                      }, null, 4),
                      _hoisted_557,
                      _hoisted_558
                    ])
                  ]),
                  _hoisted_559
                ]),
                _hoisted_560
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-07')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_562, [
          _createElementVNode("div", _hoisted_563, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.toggleModal(10)))
            }, _hoisted_565),
            _createElementVNode("div", _hoisted_566, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.toggleModal(10)))
              }, _hoisted_568),
              _hoisted_569
            ]),
            _createElementVNode("div", _hoisted_570, [
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_573, 4),
              _createElementVNode("div", _hoisted_574, [
                _hoisted_575,
                _createElementVNode("div", _hoisted_576, [
                  _createElementVNode("div", _hoisted_577, [
                    _createElementVNode("div", _hoisted_578, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station10-1.png')})`})
                      }, null, 4),
                      _hoisted_579,
                      _hoisted_580
                    ]),
                    _createElementVNode("div", _hoisted_581, [
                      _createElementVNode("div", {
                        class: "thumbnail",
                        style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station10-2.png')})`})
                      }, null, 4),
                      _hoisted_582,
                      _hoisted_583
                    ])
                  ]),
                  _hoisted_584
                ]),
                _hoisted_585
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentDate.isSameOrAfter(_ctx.dayjs('2022-05-28')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_587, [
          _hoisted_588,
          _hoisted_589,
          _createElementVNode("div", _hoisted_590, [
            _createElementVNode("button", {
              class: "act-modal-close",
              onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.toggleModal(11)))
            }, _hoisted_592),
            _createElementVNode("div", _hoisted_593, [
              _createElementVNode("button", {
                class: "actm-modal-close",
                onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.toggleModal(11)))
              }, _hoisted_595),
              _hoisted_596
            ]),
            _createElementVNode("div", _hoisted_597, [
              _hoisted_598,
              _hoisted_599,
              _hoisted_600,
              _hoisted_601,
              _createElementVNode("div", {
                class: "act-modal-ribbon",
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/ribbon-large.svg')})`})
              }, _hoisted_603, 4),
              _createElementVNode("div", _hoisted_604, [
                _hoisted_605,
                _createElementVNode("div", _hoisted_606, [
                  _createElementVNode("div", _hoisted_607, [
                    _createElementVNode("div", _hoisted_608, [
                      _createElementVNode("div", _hoisted_609, [
                        _createElementVNode("div", {
                          class: "thumbnail",
                          style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/images/activity/user_station11.png')})`})
                        }, null, 4),
                        _hoisted_610,
                        _hoisted_611
                      ])
                    ])
                  ]),
                  _hoisted_612
                ]),
                _hoisted_613
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}